<template>
	<div class="page-main" style="position: relative; " :id="backtop_id">
		<div class="sign_up_container" style="width: 1200px; display: flex; flex-direction: column;" v-if="page_index == 1">
			
			<!-- 报名 -->
			<div style="display: inline-flex; flex-direction: column; width: 1200px;  z-index: 3;">
				<div style="display: flex; margin: 70px 0 40px 0;">
					<div style="margin-right: 10px;width: 5px;background: linear-gradient(to bottom,#ff9000,#c93a2e);">
					</div>
					<div style="display: flex;flex-direction: column; line-height: 1;font-size: 28px; color: #333;">
						报名
					</div>
				</div>
			</div>
			
			<!-- 黑名单用户显示-->
			<div v-if="detailData && detailData.is_black == 1" style=" display: flex;flex-direction: column; justify-content: center; align-items: center; font-size: 18px; min-height: 75vh ; background-color: #fff; box-shadow: 1px 2px 1px #eee; border-radius: 15px; padding:35px; margin-bottom: 60px; line-height: 1;">
				抱歉，您的账号已被标记为可疑账号，暂无法报名，如需解封请联系客服经理。
			</div>
			
			<!-- 正常用户显示 -->
			<div v-if="detailData && detailData.is_black == 0" style="display: flex;flex-direction: column; background-color: #fff; box-shadow: 1px 2px 1px #eee; border-radius: 15px; padding: 35px; margin-bottom: 60px; line-height: 1;">
				<div style="display: flex; justify-content: space-between;padding-bottom: 22px; border-bottom: 1px solid #eee;">
					<div style="display: flex; flex-direction: column;font-size: 18px; color: #333;">
						<div style="font-weight: 600;">项目</div>
						<div style="margin-top: 40px;">{{detailData.title}}</div>
					</div>
					<div style="display: flex; flex-direction: column; justify-content: flex-end;" v-if="price">
						<div style="font-size: 12px; color: #ff9000;">总计</div>
						<div style="font-size: 18px; color: #333; margin-top: 24px;">{{price}} x {{gift_count}} =
							￥{{total_fee}}
						</div>
					</div>
				</div>

				<div style=" margin-top: 15px;" v-if="detailData && detailData.is_open_pay==1 && detailData.is_online_pay ==1 && detailData.is_onsite_pay ==1 && detailData.case_type != 2 && detailData.price != 0">
					<el-alert title="支付方式说明" type="warning" description="本项目支持微信在线支付、对公转账及现场缴费，提交完报名信息后，系统引导您选择支付方式，并提供对公支付、转账信息，无论您选择哪种支付方式，均可开具发票。" show-icon>
					</el-alert>
				</div>


				<div style="display: flex;flex-direction: column;">
					<div style="font-size: 18px;color: #333;font-weight: 600; padding: 40px 0;">
						报名信息
					</div>


					<div style="display: inline-block; width: 640px;">
						<el-form :model="dynamicValidateForm" ref="dynamicValidateForm" label-width="260px" >

							<div v-for="(domain, index) in dynamicValidateForm.domains" :key="domain.key">
								
								<div style="display: flex; align-items: center;">
									<el-divider content-position="left" v-if="index>0">报名人员 +{{index}}</el-divider>
									
									<el-divider content-position="right" v-if="index>0">
									<span @click.prevent="removeDomain(domain)" style="cursor: pointer;">移除 <i class="el-icon-delete"></i></span>
									</el-divider>
								</div>
								

								<el-form-item v-if="detailData.is_package==1"
									:prop="'domains.' + index + '.package_items'" label="参加"
									:rules="[{ required: true, message: '请选择您想要参加的项目', trigger: ['blur', 'change'] }]">
									<el-radio-group v-model="domain.package_items" style="margin-top:5px"
										@change="changePackageItems" :disabled="domain.package_items_disabled">
										<el-radio v-for="package_item in detailData.package_items"
											:label="package_item.id">{{package_item.title}}
											{{package_item.price}}<span style="font-size: 12px; margin-left: 10px;" v-if="package_item.student_price">学生价：{{package_item.student_price}}</span>
										</el-radio>
									</el-radio-group>
								</el-form-item>
								
							<div v-if="id!='t_819eb6f47ed245f095779e5b4d039316' 
							&& id!='t_d396f3411518405ab681cfadd66d3464' 
							&& id!='t_ed9be02623324952aa5cad2d73792f6a'">
								<el-form-item :prop="'domains.' + index + '.name'" label="姓名"
									:rules="[{ required: true, message: '请输入姓名', trigger: ['blur', 'change'] }]">
									<el-input v-model="domain.name" placeholder="请输入姓名"></el-input>
								</el-form-item>
								<el-form-item :prop="'domains.' + index + '.mobile'" label="手机"
									:rules="[{ required: true, message: '请输入手机号码', trigger: ['blur', 'change'] },{ pattern: /^[1][3-9][0-9]{9}$/, message: '请输入正确的手机号码', trigger: ['blur', 'change'] }]">
									<el-input @blur="inputMobileBlurEvent" v-model="domain.mobile"
										placeholder="请输入手机号码"></el-input>
								</el-form-item>
								<el-form-item :prop="'domains.' + index + '.email'" label="邮箱"
									:rules="[{ required: true, message: '请输入邮箱地址', trigger: ['blur', 'change'] },{ type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }]">
									<el-input  @blur="inputEmailBlurEvent" v-model="domain.email" placeholder="请输入电子邮箱地址"></el-input>
								</el-form-item>
								<el-form-item :prop="'domains.' + index + '.wechat_id'" label="微信号" :rules="[{ required: true, message: '请输入微信号', trigger: ['blur', 'change'] }]">
									<div style=" line-height: 1.4; margin: 12px 0;color: #999">
										为了方便建立会议群，请您提供微信号
									</div>
									<el-input v-model="domain.wechat_id" placeholder="请输入微信号"></el-input>
								</el-form-item>
								
								<el-form-item :prop="'domains.' + index + '.sex'" label="性别"
									:rules="[{ required: true, message: '请选择性别', trigger: 'change' }]">
									<el-radio-group v-model="domain.sex">
										<el-radio label="男"></el-radio>
										<el-radio label="女"></el-radio>
									</el-radio-group>
								</el-form-item>
								<!-- <el-form-item v-if="domain.is_show_more" :prop="'domains.' + index + '.diet_type'"
									label="餐饮" :rules="[{ required: true, message: '请选择餐饮类型', trigger: 'change' }]">
									<el-radio-group v-model="domain.diet_type">
										<el-radio label="清真"></el-radio>
										<el-radio label="非清真"></el-radio>
									</el-radio-group>
								</el-form-item> -->
								<el-form-item :prop="'domains.' + index + '.job_type'" label="身份"
									:rules="[{ required: true, message: '请选择身份类型', trigger: 'change' }]">
									<!-- <el-radio-group v-model="domain.job_type" @input="jobTypeChangeEvent"
										:disabled="domain.job_type_disabled">
										<el-radio label="教师"></el-radio>
										<el-radio label="学生"></el-radio>
										<el-radio label="其他"></el-radio>
									</el-radio-group>
									 -->
									<el-radio-group v-model="domain.job_type" @input="jobTypeChangeEvent"
										:disabled="domain.job_type_disabled" >
										<el-radio :label="job_type_item" v-for="job_type_item in detailData.job_type_items"></el-radio>
									</el-radio-group>
								</el-form-item>
								
								<el-form-item v-if="domain.job_type == '教师' || domain.job_type == '学生'"
									:prop="'domains.' + index + '.school'" label="学校"
									:rules="[ { required: true, message: '请输入学校', trigger: ['blur', 'change'] }]">
									<el-input v-model="domain.school" placeholder="请输入所在学校全称"></el-input>
								</el-form-item>
								<el-form-item v-if="domain.job_type == '教师' || domain.job_type == '学生'"
									:prop="'domains.' + index + '.college'" label="院系"
									:rules="[ { required: true, message: '请输入院系', trigger: ['blur', 'change'] }]">
									<el-input v-model="domain.college" placeholder="请输入院系"></el-input>
								</el-form-item>
								<el-form-item v-if="domain.job_type == '教师'" :prop="'domains.' + index + '.title'"
									label="职称"
									:rules="[ { required: true, message: '请输入职称', trigger: ['blur', 'change'] }]">
									<el-input v-model="domain.title" placeholder="请输入职称"></el-input>
								</el-form-item>
								
								
								<el-form-item v-if="domain.job_type == '其他'" :prop="'domains.' + index + '.company'"
									label="公司(单位)名称"
									:rules="[ { required: true, message: '请输入公司或单位名称', trigger: ['blur', 'change'] }]">
									<el-input v-model="domain.company" placeholder="请输入公司(单位)名称"></el-input>
								</el-form-item>
								<el-form-item v-if="domain.job_type == '其他'" :prop="'domains.' + index + '.department'"
									label="公司(单位)部门"
									:rules="[ { required: true, message: '请输入公司或单位部门名称', trigger: ['blur', 'change'] }]">
									<el-input v-model="domain.department" placeholder="请输入公司(单位)部门名称"></el-input>
								</el-form-item>
								
								
								<el-form-item v-if="domain.job_type == '教师' || domain.job_type == '其他'" :prop="'domains.' + index + '.duty'"
									label="职务"
									:rules="[ { required: true, message: '请输入职务', trigger: ['blur', 'change'] }]">
									<el-input v-model="domain.duty" placeholder="请输入职务"></el-input>
								</el-form-item>
								<el-form-item v-if="detailData.is_simple_info == 0 && domain.job_type == '教师'"
									:prop="'domains.' + index + '.teaching_length'" label="教龄"
									:rules="[{ required: true, message: '请输入教龄', trigger: ['blur', 'change'] },{ type: 'number', message: '教龄必须为数字类型', trigger: ['blur', 'change']}]">
									<el-input v-model.number="domain.teaching_length" placeholder="请输入教龄"></el-input>
								</el-form-item>

								
								<el-form-item v-if="detailData.is_simple_info == 0  && (domain.job_type == '学生' || domain.job_type == '其他')"
									:prop="'domains.' + index + '.education'" label="学历"
									:rules="[{ required: true, message: '请选择学历', trigger: 'change' }]">
									<el-radio-group v-model="domain.education">
										<el-radio label="专科"></el-radio>
										<el-radio label="本科"></el-radio>
										<el-radio label="硕士"></el-radio>
										<el-radio label="博士"></el-radio>
									</el-radio-group>
								</el-form-item>
								
								<!-- 是否报告 -->
								<el-form-item v-if="detailData.has_report == 1" :prop="'domains.' + index + '.is_report'" label="是否有做报告意向" :rules="[{ required: true, message: '请选择', trigger: 'change' }]">
									<el-radio-group v-model="domain.is_report">
										<el-radio label="是"></el-radio>
										<el-radio label="否"></el-radio>
									 </el-radio-group>
								</el-form-item>
								
								<!-- 报告名称 -->
								<el-form-item v-if="domain.is_report == '是'" :prop="'domains.' + index + '.report_title'" label="报告名称" :rules="[ { required: true, message: '请输入报名名称', trigger: ['blur', 'change'] }]">
									<el-input v-model="domain.report_title" placeholder="请输入报告名称"></el-input>
								</el-form-item>
								
								<!-- 2026年汽车服务工程专业委员会年会暨面向AI与智能车辆发展专业建设研讨会 -->
								<div v-if="id=='t_b2e6a291c3414761b37c1428124b297d'">
									
									<!-- 报告时长 -->
									<el-form-item v-if="domain.is_report == '是'" :prop="'domains.' + index + '.report_duration'" label="报告时长" :rules="[{ required: true, message: '请输入报告时长（分钟数）', trigger: ['blur', 'change'] },{ type: 'number', message: '报告时长必须为数字类型', trigger: ['blur', 'change']}]">
										<el-input v-model.number="domain.report_duration" placeholder="请输入报告时长（分钟数）"></el-input>
									</el-form-item>
									
									<!-- 报告时间 -->
									<el-form-item v-if="domain.is_report == '是'" :prop="'domains.' + index + '.report_date'" label="报告时间" :rules="[ { required: true, message: '请输入报告时间', trigger: ['blur', 'change'] }]">
										<!-- <el-input v-model="domain.report_date" placeholder="请输入报告时间（几月几日作报告）"></el-input> -->
										<el-date-picker
											  v-model="domain.report_date"
											  type="datetime"
											  placeholder="请选择报告时间"
											  format="yyyy-MM-dd HH:mm:ss"
											  value-format="yyyy-MM-dd HH:mm:ss"
											   popper-class="report_date"
											  :default-value="defaultReportDate"
											  :picker-options="pickerOptions">
										</el-date-picker>
									</el-form-item>
									
									<!-- 报告顺序 -->
									<el-form-item v-if="domain.is_report == '是'" :prop="'domains.' + index + '.report_order_by'" label="报告顺序" :rules="[ { required: true, message: '请输入报告顺序（第几个作报告）', trigger: ['blur', 'change'] }, { type: 'number', message: '报告顺序必须为数字类型', trigger: ['blur', 'change']}]">
										<el-input v-model.number="domain.report_order_by" placeholder="请输入报告顺序（第几个作报告）"></el-input>
									</el-form-item>
								
								</div>
								
							</div>
							
							
							
							<div v-if="id=='t_d396f3411518405ab681cfadd66d3464' || id=='t_ed9be02623324952aa5cad2d73792f6a'">
								
								<el-form-item :prop="'domains.' + index + '.name'" label="姓名"
									:rules="[{ required: true, message: '请输入姓名', trigger: ['blur', 'change'] }]">
									<el-input v-model="domain.name" placeholder="请输入姓名"></el-input>
								</el-form-item>
								
								<el-form-item :prop="'domains.' + index + '.mobile'" label="手机"
									:rules="[{ required: true, message: '请输入手机号码', trigger: ['blur', 'change'] },{ pattern: /^[1][3-9][0-9]{9}$/, message: '请输入正确的手机号码', trigger: ['blur', 'change'] }]">
									<el-input @blur="inputMobileBlurEvent" v-model="domain.mobile"
										placeholder="请输入手机号码"></el-input>
								</el-form-item>
								
								<el-form-item :prop="'domains.' + index + '.email'" label="邮箱"
									:rules="[{ required: true, message: '请输入邮箱地址', trigger: ['blur', 'change'] },{ type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }]">
									<el-input  @blur="inputEmailBlurEvent" v-model="domain.email" placeholder="请输入电子邮箱地址"></el-input>
								</el-form-item>
								
								<el-form-item :prop="'domains.' + index + '.sex'" label="性别"
									:rules="[{ required: true, message: '请选择性别', trigger: 'change' }]">
									<el-radio-group v-model="domain.sex">
										<el-radio label="男"></el-radio>
										<el-radio label="女"></el-radio>
									</el-radio-group>
								</el-form-item>

								<el-form-item label="学校所在省市区" :prop="'domains.' + index + '.school_pca'" :rules="[{ required: true, message: '请选择省市区', trigger: ['blur', 'change']}]">
									<el-cascader size="medium" placeholder="请选择省市区" :options="options" v-model="domain.school_pca"  :props="{label:'name',value:'name',children:'children' }" filterable ></el-cascader>
								</el-form-item>
							
								<el-form-item v-if="domain.job_type == '教师' || domain.job_type == '学生'"
									:prop="'domains.' + index + '.school'" label="学校"
									:rules="[ { required: true, message: '请输入学校', trigger: ['blur', 'change'] }]">
									<el-input v-model="domain.school" placeholder="请输入所在学校全称"></el-input>
								</el-form-item>
								
								<el-form-item v-if="domain.job_type == '教师'" :prop="'domains.' + index + '.title'"
									label="职称"
									:rules="[ { required: true, message: '请输入职称', trigger: ['blur', 'change'] }]">
									<el-input v-model="domain.title" placeholder="请输入职称"></el-input>
								</el-form-item>
								
								<el-form-item v-if="domain.job_type == '教师' || domain.job_type == '其他'" :prop="'domains.' + index + '.duty'"
									label="职务"
									:rules="[ { required: true, message: '请输入职务', trigger: ['blur', 'change'] }]">
									<el-input v-model="domain.duty" placeholder="请输入职务"></el-input>
								</el-form-item>
								
								<el-form-item v-if="domain.job_type == '教师'"
									:prop="'domains.' + index + '.subject'" label="学科"
									:rules="[{ required: true, message: '请输入学科', trigger: ['blur', 'change'] }]">
									<el-input v-model.number="domain.subject" placeholder="请输入学科"></el-input>
								</el-form-item>
							
							</div>
							
							<div v-if="id=='t_819eb6f47ed245f095779e5b4d039316'">
								<el-form-item :prop="'domains.' + index + '.name'" label="姓名"
									:rules="[{ required: true, message: '请输入姓名', trigger: ['blur', 'change'] }]">
									<el-input v-model="domain.name" placeholder="请输入姓名"></el-input>
								</el-form-item>
								
								<el-form-item :prop="'domains.' + index + '.sex'" label="性别"
									:rules="[{ required: true, message: '请选择性别', trigger: 'change' }]">
									<el-radio-group v-model="domain.sex">
										<el-radio label="男"></el-radio>
										<el-radio label="女"></el-radio>
									</el-radio-group>
								</el-form-item>
								

								<el-form-item :prop="'domains.' + index + '.job_type'" label="身份"
									:rules="[{ required: true, message: '请选择身份类型', trigger: 'change' }]">
									<el-radio-group v-model="domain.job_type" @input="jobTypeChangeEvent"
										:disabled="domain.job_type_disabled">
										<el-radio label="教师"></el-radio>
										<el-radio label="其他"></el-radio>
									</el-radio-group>
								</el-form-item>
								
								<el-form-item v-if="domain.job_type == '其他'" :prop="'domains.' + index + '.company'"
									label="公司(单位)名称"
									:rules="[ { required: true, message: '请输入公司或单位名称', trigger: ['blur', 'change'] }]">
									<el-input v-model="domain.company" placeholder="请输入公司(单位)名称"></el-input>
								</el-form-item>
								<el-form-item v-if="domain.job_type == '其他'" :prop="'domains.' + index + '.department'"
									label="公司(单位)部门"
									:rules="[ { required: true, message: '请输入公司或单位部门名称', trigger: ['blur', 'change'] }]">
									<el-input v-model="domain.department" placeholder="请输入公司(单位)部门名称"></el-input>
								</el-form-item>
								
								<el-form-item v-if="domain.job_type == '教师' || domain.job_type == '学生'"
									:prop="'domains.' + index + '.school'" label="所在院校"
									:rules="[ { required: true, message: '请输入所在院校全称', trigger: ['blur', 'change'] }]">
									<el-input v-model="domain.school" placeholder="请输入所在院校全称"></el-input>
								</el-form-item>
								
								<el-form-item v-if="domain.job_type == '教师' || domain.job_type == '学生'"
									:prop="'domains.' + index + '.college'" label="二级院系"
									:rules="[ { required: true, message: '请输入二级院系名称', trigger: ['blur', 'change'] }]">
									<el-input v-model="domain.college" placeholder="请输入二级院系名称"></el-input>
								</el-form-item>
								
								<el-form-item v-if="domain.job_type == '教师'"
									:prop="'domains.' + index + '.major'" label="教学专业类型"
									:rules="[ { required: true, message: '请选择教学专业类型', trigger: ['blur', 'change'] }]">
									<el-select v-model="domain.major" placeholder="请选择教学专业类型" style="width: 100%;">
									   <el-option
									     v-for="item in majorList"
									     :key="item.label"
									     :label="item.label"
									     :value="item.label">
									   </el-option>
									 </el-select>
								</el-form-item>
								
								<el-form-item v-if="domain.job_type == '教师'"
									:prop="'domains.' + index + '.course'" label="主要教授专业课程"
									:rules="[ { required: true, message: '请输入主要教授专业课程', trigger: ['blur', 'change'] }]">
									<el-input v-model="domain.course" placeholder="请输入主要教授专业课程"></el-input>
									
								</el-form-item>
								
								
								
								<el-form-item  :prop="'domains.' + index + '.duty'"
									label="职务"
									:rules="[ { required: true, message: '请选择职务', trigger: ['blur', 'change'] }]">
									<el-select v-model="domain.duty" placeholder="请选择职务" style="width: 100%;">
									   <el-option
									     v-for="item in dutyList"
									     :key="item.label"
									     :label="item.label"
									     :value="item.label">
									   </el-option>
									 </el-select>
								</el-form-item>
								<el-form-item v-if="domain.duty == '其他'"  :prop="'domains.' + index + '.duty_other'"
									label="其他职务"
									:rules="[ { required: true, message: '请输入其他职务', trigger: ['blur', 'change'] }]">
									<el-input v-model="domain.duty_other" placeholder="请输入其他职务"></el-input>
								</el-form-item>
								
								
								<el-form-item :prop="'domains.' + index + '.title'"
									label="职称"
									:rules="[ { required: true, message: '请选择职称', trigger: ['blur', 'change'] }]">

									 <el-select v-model="domain.title" placeholder="请选择职称" style="width: 100%;">
									    <el-option
									      v-for="item in titleList"
									      :key="item.label"
									      :label="item.label"
									      :value="item.label">
									    </el-option>
									  </el-select>
								</el-form-item>
								<el-form-item v-if="domain.title == '其他'"  :prop="'domains.' + index + '.title_other'"
									label="其他职称" 
									:rules="[ { required: true, message: '请输入其他职称', trigger: ['blur', 'change'] }]">
									<el-input v-model="domain.title_other" placeholder="请输入其他职称"></el-input>
								</el-form-item>
								
							
								
								
								<el-form-item :prop="'domains.' + index + '.mobile'" label="手机号"
									:rules="[{ required: true, message: '请输入手机号码', trigger: ['blur', 'change'] },{ pattern: /^[1][3-9][0-9]{9}$/, message: '请输入正确的手机号码', trigger: ['blur', 'change'] }]">
									<el-input @blur="inputMobileBlurEvent" v-model="domain.mobile"
										placeholder="请输入手机号码"></el-input>
								</el-form-item>
								
								<el-form-item :prop="'domains.' + index + '.email'" label="邮箱"
									:rules="[{ required: true, message: '请输入邮箱地址', trigger: ['blur', 'change'] },{ type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }]">
									<el-input  @blur="inputEmailBlurEvent" v-model="domain.email" placeholder="请输入电子邮箱地址"></el-input>
								</el-form-item>
							</div>

								<!-- 网安 -->
								<div v-if="id == 't_86331296ae324124bf1072a0d3a018fe'">

									<el-form-item :prop="'domains.' + index + '.check_in_date'" label="报到日期"
										:rules="[{ required: true, message: '请选择报道日期', trigger: ['blur', 'change'] }]">
										<div style=" line-height: 1.4; margin: 12px 0;color: #999">
											报到地址：合肥乐富强铂悦酒店（酒店地址：安徽省合肥市蜀山区创新大道229号，联系电话：1832660374724）
										</div>
										<el-radio-group v-model="domain.check_in_date">
											<el-radio label="4月12日"></el-radio>
											<el-radio label="4月13日9:00前（报到地址：合肥乐富强铂悦酒店）"></el-radio>
											<el-radio label="4月13日9:00前（报到地址：中国科学技术大学高新园区）"></el-radio>
											<el-radio label="其他"></el-radio>
										</el-radio-group>
									</el-form-item>

									<el-form-item v-if="domain.check_in_date == '其他'"
										:prop="'domains.' + index + '.check_in_date_other'" label="其他报到日期"
										:rules="[ { required: true, message: '请输入其他报道日期', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.check_in_date_other"
											placeholder="请输入其他报到日期"></el-input>
									</el-form-item>


									<el-form-item :prop="'domains.' + index + '.room_type'" label="您对入住房型的需求"
										:rules="[{ required: true, message: '请选择您对入住房型的需求', trigger: ['blur', 'change'] }]">
										<div style="line-height: 1.4;margin: 12px 0;color: #999">
											合肥乐富强铂悦酒店<br>
											协议价：大床房（含单早）350元/天，标准间（含单早）350元/天、标准间（含双早）410元/天
										</div>
										<el-radio-group v-model="domain.room_type">
											<el-radio label="大床房"></el-radio>
											<el-radio label="双床房(单住)"></el-radio>
											<el-radio label="双床房(合住)"></el-radio>
											<el-radio label="不住宿"></el-radio>
											<el-radio label="其他"></el-radio>
										</el-radio-group>
									</el-form-item>

									<el-form-item v-if="domain.room_type == '其他'"
										:prop="'domains.' + index + '.room_type_other'" label="其他入住房型的需求"
										:rules="[ { required: true, message: '请输入其他入住房型的需求', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.room_type_other"
											placeholder="请输入其他入住房型的需求"></el-input>
									</el-form-item>


									<el-form-item v-if="domain.room_type == '双床房(合住)'"
										:prop="'domains.' + index + '.room_share_with'" label="合住人姓名"
										:rules="[ { required: true, message: '请输入合住人姓名', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.room_share_with" placeholder="请输入合住人姓名"></el-input>
									</el-form-item>


									<el-form-item :prop="'domains.' + index + '.is_visit'" label="您是否参加14日下午的参观考察？"
										:rules="[{ required: true, message: '请选择您是否参加参观考察', trigger: ['blur', 'change'] }]">
										<div style="line-height: 1.4;margin: 12px 0; color: #999;">
											本源量子、科大先研院（龙芯中科）、新华三等合肥市高新技术企业</div>

										<el-radio-group v-model="domain.is_visit">
											<el-radio label="是"></el-radio>
											<el-radio label="否"></el-radio>
										</el-radio-group>
									</el-form-item>

								</div>



								<!-- SOLIDWORKS -->
								<div v-if="id == 't_8c168c7c2ab741ec87ae4b324793f394'">
									<el-form-item label="住宿">
										<div style=" line-height: 1.4; margin: 12px 0;color: #999">
											会议地点提供住宿服务：大连栖悦酒店（辽宁省大连市甘井子区大连门广场1号）标准间、大床房均为350元/间，均含早餐。请自行联系酒店预定房间，联系人:林经理，订房电话：155
											6688 8849。
										</div>
									</el-form-item>
								</div>

								<!-- <div v-if="id == 't_8c168c7c2ab741ec87ae4b324793f394'">
									
									<el-form-item  :prop="'domains.' + index + '.check_in_date'" label="报到日期" :rules="[{ required: true, message: '请选择报道日期', trigger: ['blur', 'change'] }]">
										<div style=" line-height: 1.4; margin: 12px 0;color: #999">
											报到地址：中铁国资北戴河分公司（河北省秦皇岛市北戴河区滨海大道2号），报到、住宿联系人齐老师 15133550003、王老师 18432266111
										</div>
										<el-radio-group v-model="domain.check_in_date">
										    <el-radio label="5月16日"></el-radio>
										    <el-radio label="5月17日"></el-radio>
											<el-radio label="其他"></el-radio>
										</el-radio-group>
									</el-form-item>
									
									<el-form-item v-if="domain.check_in_date == '其他'" :prop="'domains.' + index + '.check_in_date_other'" label="其他报到日期" :rules="[ { required: true, message: '请输入其他报道日期', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.check_in_date_other" placeholder="请输入其他报到日期"></el-input>
									</el-form-item>
									
									
									<el-form-item :prop="'domains.' + index + '.room_type'" label="住宿选择" :rules="[{ required: true, message: '请选择您对入住房型的需求', trigger: ['blur', 'change'] }]">
										<div style="line-height: 1.4;margin: 12px 0;color: #999">
											会务组统一为您预定房间<br>
											标准间：280 元/间，大床房：350 元/间，均含早餐
										</div>
										<el-radio-group v-model="domain.room_type">
										    <el-radio label="大床房"></el-radio>
										    <el-radio label="标准间(单住)"></el-radio>
											<el-radio label="标准间(合住)"></el-radio>
											<el-radio label="不住宿"></el-radio>
											<el-radio label="其他"></el-radio>
										</el-radio-group>
									</el-form-item>
									
									<el-form-item v-if="domain.room_type == '其他'" :prop="'domains.' + index + '.room_type_other'" label="其他入住房型的需求" :rules="[ { required: true, message: '请输入其他入住房型的需求', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.room_type_other" placeholder="请输入其他入住房型的需求"></el-input>
									</el-form-item>
									
									
									<el-form-item v-if="domain.room_type == '标准间(合住)'" :prop="'domains.' + index + '.room_share_with'" label="合住人姓名" :rules="[ { required: true, message: '请输入合住人姓名', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.room_share_with" placeholder="请输入合住人姓名"></el-input>
									</el-form-item>

								</div> -->


								<!-- 新能源汽车 -->
								<div v-if="id == 't_8d955ddd69204696b061b5de87f35161'">

									<el-form-item :prop="'domains.' + index + '.room_type'" label="住宿选择"
										:rules="[{ required: true, message: '请选择您对入住房型的需求', trigger: ['blur', 'change'] }]">
										<div style="line-height: 1.4;margin: 12px 0;color: #999">
											福建厦门佰翔软件园酒店（厦门市湖里区观日路1号）<br>
											协议价：400元/天（标准房、大床房），会务组视当天房间情况随机安排房型，酒店联系人 何仕杰18050059902
										</div>
										<el-radio-group v-model="domain.room_type">
											<el-radio label="单人入住"></el-radio>
											<el-radio label="与指定人员拼房"></el-radio>
											<el-radio label="会务组随机拼房"></el-radio>
											<el-radio label="不住宿"></el-radio>
											<el-radio label="其他"></el-radio>
										</el-radio-group>
									</el-form-item>

									<el-form-item v-if="domain.room_type == '其他'"
										:prop="'domains.' + index + '.room_type_other'" label="其他入住房型的需求"
										:rules="[ { required: true, message: '请输入其他入住房型的需求', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.room_type_other"
											placeholder="请输入其他入住房型的需求"></el-input>
									</el-form-item>


									<el-form-item v-if="domain.room_type == '与指定人员拼房'"
										:prop="'domains.' + index + '.room_share_with'" label="合住人姓名"
										:rules="[ { required: true, message: '请输入合住人姓名', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.room_share_with" placeholder="请输入合住人姓名"></el-input>
									</el-form-item>

								</div>


								<!-- 扎根 -->
								<div v-if="id == 't_8e4a37fb05364034980726c88b53d529'">

									<el-form-item :prop="'domains.' + index + '.room_type_before'" label="房型需求"
										:rules="[{ required: true, message: '请选择您对入住房型的需求', trigger: ['blur', 'change'] }]">
										<div style="line-height: 1.4;margin: 12px 0;color: #999">
											会议报到及推荐入住酒店：<br>
											青岛华澜大酒店（青岛市李沧区金水路171号）。<br>
											40平米客房协议价：380元/天（标准房、大床房），30平米客房协议价：330元/天（标准房、大床房 ，已订满），会务组视当天房间情况随机安排单人房型。
										</div>
										<el-radio-group v-model="domain.room_type_before">
											<el-radio label="40平米客房"></el-radio>
											<el-radio label="30平米客房（已订满）" disabled></el-radio>
											<el-radio label="不住宿"></el-radio>
											<el-radio label="其他"></el-radio>
										</el-radio-group>
									</el-form-item>

									<el-form-item v-if="domain.room_type_before == '其他'"
										:prop="'domains.' + index + '.room_type_other'" label="其他入住房型的需求"
										:rules="[ { required: true, message: '请输入其他入住房型的需求', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.room_type_other"
											placeholder="请输入其他入住房型的需求"></el-input>
									</el-form-item>

									<el-form-item
										v-if="domain.room_type_before == '40平米客房' || domain.room_type_before == '30平米客房'"
										:prop="'domains.' + index + '.room_type'" label="入住方式"
										:rules="[{ required: true, message: '请选择入住方式', trigger: ['blur', 'change'] }]">
										<el-radio-group v-model="domain.room_type">
											<el-radio label="单人入住"></el-radio>
											<el-radio label="与指定人员拼房"></el-radio>
											<el-radio label="会务组随机拼房"></el-radio>
										</el-radio-group>
									</el-form-item>


									<el-form-item v-if="domain.room_type == '与指定人员拼房'"
										:prop="'domains.' + index + '.room_share_with'" label="合住人姓名"
										:rules="[ { required: true, message: '请输入合住人姓名', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.room_share_with" placeholder="请输入合住人姓名"></el-input>
									</el-form-item>

								</div>


								<!-- 新能源汽车 -->
								<div v-if="id == 't_8f44faaea70849d49f5c7ca486b9b453'">

									<el-form-item :prop="'domains.' + index + '.room_type'" label="住宿选择"
										:rules="[{ required: true, message: '请选择您对入住房型的需求', trigger: ['blur', 'change'] }]">
										<div style="line-height: 1.4;margin: 12px 0;color: #999">
											广州芳华美宿（广东省广州市番禺区沙湾街市良路1342号广州番禺职业技术学院院内）<br>
											协议价：328元/天（含双早）
										</div>
										<el-radio-group v-model="domain.room_type">
											<el-radio label="单人入住"></el-radio>
											<el-radio label="与指定人员拼房"></el-radio>
											<el-radio label="会务组随机拼房"></el-radio>
											<el-radio label="不住宿"></el-radio>
											<el-radio label="其他"></el-radio>
										</el-radio-group>
									</el-form-item>

									<el-form-item v-if="domain.room_type == '其他'"
										:prop="'domains.' + index + '.room_type_other'" label="其他入住房型的需求"
										:rules="[ { required: true, message: '请输入其他入住房型的需求', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.room_type_other"
											placeholder="请输入其他入住房型的需求"></el-input>
									</el-form-item>


									<el-form-item v-if="domain.room_type == '与指定人员拼房'"
										:prop="'domains.' + index + '.room_share_with'" label="合住人姓名"
										:rules="[ { required: true, message: '请输入合住人姓名', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.room_share_with" placeholder="请输入合住人姓名"></el-input>
									</el-form-item>

								</div>


								<!-- 无人机 -->
								<div v-if="id == 't_8h28e4cf4ef6574730a16bc569232e0e'">


									<el-form-item :prop="'domains.' + index + '.room_type'" label="住宿选择"
										:rules="[{ required: true, message: '请选择您对入住房型的需求', trigger: ['blur', 'change'] }]">
										<div style="line-height: 1.4;margin: 12px 0;color: #999">
											内蒙古维力斯大酒店（呼和浩特市新城区新华东街89号）<br>
											协议价：350元/天（大床房/标间，含双早）
										</div>
										<el-radio-group v-model="domain.room_type">
											<el-radio label="单人入住"></el-radio>
											<el-radio label="与指定人员拼房"></el-radio>
											<el-radio label="会务组随机拼房"></el-radio>
											<el-radio label="不住宿"></el-radio>
											<el-radio label="其他"></el-radio>
										</el-radio-group>
									</el-form-item>

									<el-form-item v-if="domain.room_type == '其他'"
										:prop="'domains.' + index + '.room_type_other'" label="其他入住房型的需求"
										:rules="[ { required: true, message: '请输入其他入住房型的需求', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.room_type_other"
											placeholder="请输入其他入住房型的需求"></el-input>
									</el-form-item>


									<el-form-item v-if="domain.room_type == '与指定人员拼房'"
										:prop="'domains.' + index + '.room_share_with'" label="合住人姓名"
										:rules="[ { required: true, message: '请输入合住人姓名', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.room_share_with" placeholder="请输入合住人姓名"></el-input>
									</el-form-item>


									<el-form-item :prop="'domains.' + index + '.is_join'" label="是否申请加入无人机资源建设委员会？"
										:rules="[{ required: true, message: '请选择您是否申请加入', trigger: ['blur', 'change'] }]">
										<el-radio-group v-model="domain.is_join">
											<el-radio label="是"></el-radio>
											<el-radio label="否"></el-radio>
										</el-radio-group>
										<div v-if="domain.is_join == '是'"
											style="line-height: 1.4;margin: 12px 0; color: #999;">
											<div>请下载申请表，填写后发送至邮箱303431623@qq.com</div>
											<div @click="downloadClick"
												style="display: inline-block; color: rgb(41, 121, 255);border-bottom: 1px solid rgb(41, 121, 255);margin-top: 10px; cursor: pointer;">
												点击下载申请表</div>
										</div>
									</el-form-item>

									<el-form-item :prop="'domains.' + index + '.is_will'" label="是否有意愿考取CAAC民用无人机操控员执照？"
										:rules="[{ required: true, message: '请选择您是否申请加入', trigger: ['blur', 'change'] }]">
										<el-radio-group v-model="domain.is_will">
											<el-radio label="是"></el-radio>
											<el-radio label="否"></el-radio>
										</el-radio-group>
									</el-form-item>


									<el-form-item :prop="'domains.' + index + '.id_card'" label="身份证号码"
										:rules="[{ required: true, message: '请输入身份证号码', trigger: ['blur', 'change'] },{ len:18,message: '请输入正确的身份证号码', trigger: ['blur', 'change'] }]">
										<div style="line-height: 1.4;margin: 12px 0;color: #999">
											7月26日外出航拍，主办方为参与人员统一购买意外险，请各位老师填写身份证号
										</div>
										<el-input v-model="domain.id_card" placeholder="请输入身份证号码"></el-input>
									</el-form-item>

								</div>


								<!-- 数控 -->
								<div v-if="id == 't_8i4d1cf92190324a0a9ab655ced72f9f'">

									<el-form-item :prop="'domains.' + index + '.check_in_date'" label="报到日期"
										:rules="[{ required: true, message: '请选择报道日期', trigger: ['blur', 'change'] }]">
										<div style=" line-height: 1.4; margin: 12px 0;color: #999">
											报到地点：吉林省长春市绿园区新红旗大街1777号长春汽车职业技术大学（原长春汽车工业高等专科学校）
										</div>
										<el-radio-group v-model="domain.check_in_date">
											<el-radio label="7月3日"></el-radio>
											<el-radio label="7月4日"></el-radio>
											<el-radio label="其他"></el-radio>
										</el-radio-group>
									</el-form-item>

									<el-form-item v-if="domain.check_in_date == '其他'"
										:prop="'domains.' + index + '.check_in_date_other'" label="其他报到日期"
										:rules="[ { required: true, message: '请输入其他报道日期', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.check_in_date_other"
											placeholder="请输入其他报到日期"></el-input>
									</el-form-item>


									<el-form-item :prop="'domains.' + index + '.room_type'" label="住宿选择"
										:rules="[{ required: true, message: '请选择您对入住房型的需求', trigger: ['blur', 'change'] }]">
										<div style="line-height: 1.4;margin: 12px 0;color: #999">
											校内培训宾馆提供住宿服务，268.00元/标间/天
										</div>
										<el-radio-group v-model="domain.room_type">
											<el-radio label="住宿"></el-radio>
											<el-radio label="不住宿"></el-radio>
										</el-radio-group>
									</el-form-item>

								</div>


								<!-- AIGC-->
								<div v-if="id == 't_8jaa9f66f964fe41b69886ef9cebbf3f' ||  id == 't_8t714f7bafc07f490e9ba8dcf00df17d4f' || id == 't_8yb6d3f1c67a0a4d3bade212aed273c1'">

									<el-form-item :prop="'domains.' + index + '.id_card'" label="身份证号码"
										:rules="[{ required: true, message: '请输入身份证号码', trigger: ['blur', 'change'] },{ len:18,message: '请输入正确的身份证号码', trigger: ['blur', 'change'] }]">
										<div style="line-height: 1.4;margin: 12px 0;color: #999">
											为登记信息，方便后续大家考试，请各位老师填写身份证号
										</div>
										<el-input v-model="domain.id_card" placeholder="请输入身份证号码"></el-input>
									</el-form-item>
									
									
									<!-- 邮寄地址待处理 -->
									<el-form-item label="证书邮件地址" required>
										<el-col :span="24">
										  <el-form-item :prop="'domains.' + index + '.pca'" :rules="[{ required: true, message: '请选择省市区', trigger: ['blur', 'change']}]">
											<el-cascader placeholder="请选择省市区" :options="options" v-model="domain.pca"  :props="{label:'name',value:'name',children:'children' }" filterable ></el-cascader>
										  </el-form-item>
										</el-col>
										<el-col :span="24">
										  <el-form-item :prop="'domains.' + index + '.address'" :rules="[{ required: true, message: '请输入详情地址', trigger: ['blur', 'change']}]">
											<el-input v-model="domain.address" placeholder="请输入详细地址"></el-input>
										  </el-form-item>
										</el-col>
									</el-form-item> 
									
								</div>



								<!-- PLC-->
								<div v-if="id == 't_8kc6154d6cff8b47c29f537e1eae471e'">


									<el-form-item :prop="'domains.' + index + '.room_type'" label="住宿选择"
										:rules="[{ required: true, message: '请选择您对入住房型的需求', trigger: ['blur', 'change'] }]">
										<div style="line-height: 1.4;margin: 12px 0;color: #999">
											会议住宿酒店：云南昆明·中维天恒大酒店（云南省昆明市五华区青年路432号），协议价：400元/天（单早），430元/天（双早）
										</div>
										<el-radio-group v-model="domain.room_type">
											<el-radio label="单人入住"></el-radio>
											<el-radio label="与指定人员拼房"></el-radio>
											<el-radio label="会务组随机拼房"></el-radio>
											<el-radio label="不住宿"></el-radio>
											<el-radio label="其他"></el-radio>
										</el-radio-group>
									</el-form-item>

									<el-form-item v-if="domain.room_type == '其他'"
										:prop="'domains.' + index + '.room_type_other'" label="其他入住房型的需求"
										:rules="[ { required: true, message: '请输入其他入住房型的需求', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.room_type_other"
											placeholder="请输入其他入住房型的需求"></el-input>
									</el-form-item>


									<el-form-item v-if="domain.room_type == '与指定人员拼房'"
										:prop="'domains.' + index + '.room_share_with'" label="合住人姓名"
										:rules="[ { required: true, message: '请输入合住人姓名', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.room_share_with" placeholder="请输入合住人姓名"></el-input>
									</el-form-item>


									<el-form-item :prop="'domains.' + index + '.id_card'" label="身份证号码"
										:rules="[{ required: true, message: '请输入身份证号码', trigger: ['blur', 'change'] },{ len:18,message: '请输入正确的身份证号码', trigger: ['blur', 'change'] }]">
										<div style="line-height: 1.4;margin: 12px 0;color: #999">
											为登记信息，方便大家进出参观院校，请各位老师填写身份证号
										</div>
										<el-input v-model="domain.id_card" placeholder="请输入身份证号码"></el-input>
									</el-form-item>

								</div>


								<!-- 国际贸易-->
								<div v-if="id == 't_8mbfe254cbfd2e42df842fc051080e54'">

									<el-form-item :prop="'domains.' + index + '.room_type'" label="住宿选择"
										:rules="[{ required: true, message: '请选择您对入住房型的需求', trigger: ['blur', 'change'] }]">
										<div style="line-height: 1.4;margin: 12px 0;color: #999">
											请参会者自行联系酒店预订房间，报名信息我平台会及时同步酒店方。
											暑期房源紧张，请尽早联系酒店预订。<br><br>

											蒙·世家酒店（集宁区昌宁街乌兰美文旅大厦）<br>
											协议价：400元/人（商务大床/标间、不含早餐）<br>
											酒店联系人：连经理，155 4099 2983
										</div>
										<el-radio-group v-model="domain.room_type">
											<el-radio label="单人入住"></el-radio>
											<el-radio label="与指定人员拼房"></el-radio>
											<el-radio label="会务组随机拼房"></el-radio>
											<el-radio label="不住宿"></el-radio>
											<el-radio label="其他"></el-radio>
										</el-radio-group>
									</el-form-item>

									<el-form-item v-if="domain.room_type == '其他'"
										:prop="'domains.' + index + '.room_type_other'" label="其他入住房型的需求"
										:rules="[ { required: true, message: '请输入其他入住房型的需求', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.room_type_other"
											placeholder="请输入其他入住房型的需求"></el-input>
									</el-form-item>

									<el-form-item v-if="domain.room_type == '与指定人员拼房'"
										:prop="'domains.' + index + '.room_share_with'" label="合住人姓名"
										:rules="[ { required: true, message: '请输入合住人姓名', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.room_share_with" placeholder="请输入合住人姓名"></el-input>
									</el-form-item>

								</div>



								<!-- 工业互联网-->
								<div v-if="id == 't_8n29da89c6205b478d9987f083f5594f'">

									<el-form-item :prop="'domains.' + index + '.room_type'" label="住宿选择"
										:rules="[{ required: true, message: '请选择您对入住房型的需求', trigger: ['blur', 'change'] }]">
										<div style="line-height: 1.4;margin: 12px 0;color: #999">
											会议住宿酒店：重庆桃乐源酒店(江北机场桃源公园店)(重庆市渝北区双凤桥街道长凯路2号)，协议价：320元(含双早)
										</div>
										<el-radio-group v-model="domain.room_type">
											<el-radio label="单人入住"></el-radio>
											<el-radio label="与指定人员拼房"></el-radio>
											<el-radio label="会务组随机拼房"></el-radio>
											<el-radio label="不住宿"></el-radio>
											<el-radio label="其他"></el-radio>
										</el-radio-group>
									</el-form-item>

									<el-form-item v-if="domain.room_type == '其他'"
										:prop="'domains.' + index + '.room_type_other'" label="其他入住房型的需求"
										:rules="[ { required: true, message: '请输入其他入住房型的需求', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.room_type_other"
											placeholder="请输入其他入住房型的需求"></el-input>
									</el-form-item>

									<el-form-item v-if="domain.room_type == '与指定人员拼房'"
										:prop="'domains.' + index + '.room_share_with'" label="合住人姓名"
										:rules="[ { required: true, message: '请输入合住人姓名', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.room_share_with" placeholder="请输入合住人姓名"></el-input>
									</el-form-item>

								</div>


								<!-- QCA-->
								<div v-if="id == 't_8oc16aebed25b34f489e8f66e12acc7c'">

									<el-form-item label="住宿">
										<div style=" line-height: 1.4; margin: 12px 0;color: #999">
											会议酒店：盛世民航国际酒店（河南省郑州市金水路2号）<br>
											协议价：360元/天（含双早）<br>
											酒店联系人：徐经理 180 3767 3239，董经理 157 3818 1136<br>
											温馨提示：敬请与会人员自行联系酒店预订房间，订房时向酒店方表明参加“机工社培训”活动，以便享受协议优惠房价。
										</div>
									</el-form-item>

								</div>


								<!-- “五金”新基建 -->
								<div v-if="id == 't_8v669a06c7030047d0858d2c8538f135'">

									<el-form-item :prop="'domains.' + index + '.is_cert'" label="是否考取 数字化技能创新应用技术（高级）证书"
										:rules="[{ required: true, message: '请选择是否考证', trigger: ['blur', 'change'] }]">
										<el-radio-group v-model="domain.is_cert" @input="isCertChangeEvent"
											:disabled="domain.is_cert_disabled">
											<el-radio label="是"></el-radio>
											<el-radio label="否"></el-radio>
										</el-radio-group>
									</el-form-item>

									<el-form-item v-if="domain.is_cert == '是'" :prop="'domains.' + index + '.id_card'"
										label="身份证号码"
										:rules="[{ required: true, message: '请输入身份证号码', trigger: ['blur', 'change'] },{ len:18,message: '请输入正确的身份证号码', trigger: ['blur', 'change'] }]">
										<div style="line-height: 1.4;margin: 12px 0;color: #999">
											为登记信息，方便后续大家考试，请各位老师填写身份证号
										</div>
										<el-input v-model="domain.id_card" placeholder="请输入身份证号码"></el-input>
									</el-form-item>

								</div>
								
								
								<!-- 电气工程-->
								<div v-if="id == 't_8zb5f0693bbdf645b2943aa23c84e551'">
								
									<el-form-item :prop="'domains.' + index + '.room_type_before'" label="房型需求"
										:rules="[{ required: true, message: '请选择您对入住房型的需求', trigger: ['blur', 'change'] }]">
										<div style="line-height: 1.4;margin: 12px 0;color: #999">
											会议报到及推荐入住酒店：<br>
											无锡山明水秀大饭店（无锡市蠡溪路999号）。<br>
											普通标准间340元/晚（含双早）；高级标准间380元/晚（单早），420元/晚（双早）；高级大床房380元/晚（单早）
										</div>
										<el-radio-group v-model="domain.room_type_before">
											<el-radio label="普通标准间"></el-radio>
											<el-radio label="高级标准间"></el-radio>
											<el-radio label="高级大床房"></el-radio>
											<el-radio label="不住宿"></el-radio>
											<el-radio label="其他"></el-radio>
										</el-radio-group>
									</el-form-item>
								
									<el-form-item v-if="domain.room_type_before == '其他'"
										:prop="'domains.' + index + '.room_type_other'" label="其他入住房型的需求"
										:rules="[ { required: true, message: '请输入其他入住房型的需求', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.room_type_other"
											placeholder="请输入其他入住房型的需求"></el-input>
									</el-form-item>
								
									<el-form-item
										v-if="domain.room_type_before == '普通标准间' || domain.room_type_before == '高级标准间'"
										:prop="'domains.' + index + '.room_type'" label="入住方式"
										:rules="[{ required: true, message: '请选择入住方式', trigger: ['blur', 'change'] }]">
										<el-radio-group v-model="domain.room_type">
											<el-radio label="单人入住"></el-radio>
											<el-radio label="与指定人员拼房"></el-radio>
											<el-radio label="会务组随机拼房"></el-radio>
										</el-radio-group>
									</el-form-item>
								
								
									<el-form-item v-if="domain.room_type == '与指定人员拼房'"
										:prop="'domains.' + index + '.room_share_with'" label="合住人姓名"
										:rules="[ { required: true, message: '请输入合住人姓名', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.room_share_with" placeholder="请输入合住人姓名"></el-input>
									</el-form-item>
								
								</div>
								
								<!-- IT大师班：网络系统软件应用与维护的高级修炼 -->
								<div v-if="id == 't_9ha8e3448accc54e679659bdf8b99a8e'">
								
									<el-form-item  :prop="'domains.' + index + '.id_card'"
										label="身份证号码"
										:rules="[{ required: true, message: '请输入身份证号码', trigger: ['blur', 'change'] },{ len:18,message: '请输入正确的身份证号码', trigger: ['blur', 'change'] }]">
										<div style="line-height: 1.4;margin: 12px 0;color: #999">
											为登记信息，方便后续大家考试及制证，请各位老师填写身份证号
										</div>
										<el-input v-model="domain.id_card" placeholder="请输入身份证号码"></el-input>
									</el-form-item>
								
								</div>
								
								
								<!-- 2025年职业教育信息技术类专业教学标准解读与实践研讨会-->
								<div v-if="id == 't_219183e7847144f695a4f13be8885cea'">
								
									<el-form-item :prop="'domains.' + index + '.is_cert'" label="是否参加专项技术证书考试"
										:rules="[{ required: true, message: '请选择是否考证', trigger: ['blur', 'change'] }]">
										<el-radio-group v-model="domain.is_cert" @input="isCertChangeEvent"
											:disabled="domain.is_cert_disabled">
											<el-radio label="是"></el-radio>
											<el-radio label="否"></el-radio>
										</el-radio-group>
									</el-form-item>
								
									<el-form-item v-if="domain.is_cert == '是'" :prop="'domains.' + index + '.id_card'"
										label="身份证号码"
										:rules="[{ required: true, message: '请输入身份证号码', trigger: ['blur', 'change'] },{ len:18,message: '请输入正确的身份证号码', trigger: ['blur', 'change'] }]">
										<div style="line-height: 1.4;margin: 12px 0;color: #999">
											为登记信息，方便后续大家考试，请各位老师填写身份证号
										</div>
										<el-input v-model="domain.id_card" placeholder="请输入身份证号码"></el-input>
									</el-form-item>
									
									<el-form-item v-if="domain.is_cert == '是'" label="证书邮寄地址" required>
										<el-col :span="24">
										  <el-form-item :prop="'domains.' + index + '.pca'" :rules="[{ required: true, message: '请选择省市区', trigger: ['blur', 'change']}]">
											<el-cascader placeholder="请选择省市区" :options="options" v-model="domain.pca"  :props="{label:'name',value:'name',children:'children' }" filterable ></el-cascader>
										  </el-form-item>
										</el-col>
										<el-col :span="24">
										  <el-form-item :prop="'domains.' + index + '.address'" :rules="[{ required: true, message: '请输入详情地址', trigger: ['blur', 'change']}]">
											<el-input v-model="domain.address" placeholder="请输入详细地址"></el-input>
										  </el-form-item>
										</el-col>
									</el-form-item> 
								
								</div>
								
								
								<!-- 国际贸易2025-->
								<div v-if="id == 't_30c2a484e8384ba0878ca095953f7187' && domain.is_show_more">
								
									<el-form-item :prop="'domains.' + index + '.check_in_date'" label="报到日期"
										:rules="[{ required: true, message: '请选择报到日期', trigger: ['blur', 'change'] }]">
										<el-radio-group v-model="domain.check_in_date">
											<el-radio label="3月28日"></el-radio>
											<el-radio label="3月29日"></el-radio>
											<el-radio label="其他"></el-radio>
										</el-radio-group>
									</el-form-item>
									
									<el-form-item v-if="domain.check_in_date == '其他'"
										:prop="'domains.' + index + '.check_in_date_other'" label="其他报到日期"
										:rules="[ { required: true, message: '请输入其他报到日期', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.check_in_date_other"
											placeholder="请输入其他报到日期"></el-input>
									</el-form-item>
									
									
									<el-form-item :prop="'domains.' + index + '.stay_type'" label="住宿" :rules="[{ required: true, message: '请选择住宿方式', trigger: 'change' }]">
										<el-radio-group v-model="domain.stay_type">
											<el-radio label="自行安排"></el-radio>
											<el-radio label="代行预订"></el-radio>
										 </el-radio-group>
									</el-form-item>
									
									<el-form-item v-if="domain.stay_type == '代行预订'" :prop="'domains.' + index + '.hotel'" label="酒店" :rules="[{ required: true, message: '请选择您入住的酒店', trigger: ['blur', 'change'] }]">
										<div style="line-height: 1.4;margin: 12px 0;color: #999">
											◆ 厦门灵玲大酒店，地址：福建省厦门市集美区杏锦路352号<br>
											协议价：380元/人（商务大床/标间可选、含早餐）<br>
											◆厦门集美湖豪生大酒店，地址：福建省厦门市集美区立功路121号<br>
											协议价：398元/人（商务大床/标间可选、含早餐）<br>
											温馨提示：可在报名系统中选择酒店及房型；清明假期前后房源紧张，请参会教师尽早预订！<br>
										</div>
										<el-radio-group v-model="domain.hotel">
											<el-radio label="厦门灵玲大酒店" ></el-radio>
											<el-radio label="厦门集美湖豪生大酒店（已订满）"  disabled></el-radio>
										</el-radio-group>
									</el-form-item>
									
									
									<el-form-item v-if="domain.hotel =='厦门灵玲大酒店'" :prop="'domains.' + index + '.room_type_before'" label="房型"
										:rules="[{ required: true, message: '请选择您对入住房型的需求', trigger: ['blur', 'change'] }]">
										<el-radio-group v-model="domain.room_type_before">
											<el-radio label="大床房"></el-radio>
											<el-radio label="标准间"></el-radio>
											<el-radio label="其他"></el-radio>
										</el-radio-group>
									</el-form-item>
																	
									
									<el-form-item v-if="domain.room_type_before == '其他'"
										:prop="'domains.' + index + '.room_type_other'" label="其他入住房型的需求"
										:rules="[ { required: true, message: '请输入其他入住房型的需求', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.room_type_other"
											placeholder="请输入其他入住房型的需求"></el-input>
									</el-form-item>
																	
									<el-form-item v-if="domain.room_type_before"
										:prop="'domains.' + index + '.room_type'" label="入住方式"
										:rules="[{ required: true, message: '请选择入住方式', trigger: ['blur', 'change'] }]">
										<el-radio-group v-model="domain.room_type">
											<el-radio label="单人入住"></el-radio>
											<el-radio label="与指定人员拼房"></el-radio>
											<el-radio label="会务组随机拼房"></el-radio>
										</el-radio-group>
									</el-form-item>
																	
																	
									<el-form-item v-if="domain.room_type == '与指定人员拼房'"
										:prop="'domains.' + index + '.room_share_with'" label="合住人姓名"
										:rules="[ { required: true, message: '请输入合住人姓名', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.room_share_with" placeholder="请输入合住人姓名"></el-input>
									</el-form-item>
									
									<el-form-item v-if="domain.room_type_before" :prop="'domains.' + index + '.stay_days'" label="入住天数" :rules="[{ required: true, message: '请选择入住方式', trigger: ['blur', 'change'] }]">
										<el-radio-group v-model="domain.stay_days">
											<el-radio label="1天"></el-radio>
											<el-radio label="2天"></el-radio>
											<el-radio label="3天"></el-radio>
											<el-radio label="其他"></el-radio>
										</el-radio-group>
									</el-form-item>
									
									<el-form-item v-if="domain.stay_days == '其他'"
										:prop="'domains.' + index + '.stay_days_other'" label="其他入住天数"
										:rules="[ { required: true, message: '请输入其他入住天数', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.stay_days_other" placeholder="请输入其他入住天数"></el-input>
									</el-form-item>
								
								</div>
								
								
								<!-- 关于开展汽车专业方向教学能力比赛赛项解析、备赛经验和竞赛技巧分享培训 -->
								<div v-if="id == 't_819eb6f47ed245f095779e5b4d039316'">
								
								
									<el-form-item  :prop="'domains.' + index + '.id_card'"
										label="身份证号码"
										:rules="[{ required: true, message: '请输入身份证号码', trigger: ['blur', 'change'] },{ len:18,message: '请输入正确的身份证号码', trigger: ['blur', 'change'] }]">
										<div style="line-height: 1.4;margin: 12px 0;color: #999">
											为登记信息，方便后续制作证书，请填写身份证号
										</div>
										<el-input v-model="domain.id_card" placeholder="请输入身份证号码"></el-input>
									</el-form-item>
									
									<el-form-item label="证书邮寄地址" required>
										<el-col :span="24">
										  <el-form-item :prop="'domains.' + index + '.pca'" :rules="[{ required: true, message: '请选择省市区', trigger: ['blur', 'change']}]">
											<el-cascader placeholder="请选择省市区" :options="options" v-model="domain.pca"  :props="{label:'name',value:'name',children:'children' }" filterable ></el-cascader>
										  </el-form-item>
										</el-col>
										<el-col :span="24">
										  <el-form-item :prop="'domains.' + index + '.address'" :rules="[{ required: true, message: '请输入详情地址', trigger: ['blur', 'change']}]">
											<el-input v-model="domain.address" placeholder="请输入详细地址"></el-input>
										  </el-form-item>
										</el-col>
									</el-form-item> 
								
								</div>
								
								
								<!-- Deepseek助力职场效率提升-->
								<div v-if="id == 't_fa167dabbc9f4da2b2c678e0b889546b'">
								
									<el-form-item :prop="'domains.' + index + '.is_cert'" label="您是否参加人工智能专项技能（中级）证书考试？"
										:rules="[{ required: true, message: '请选择是否考证', trigger: ['blur', 'change'] }]">
										<div style="line-height: 1.4;margin: 12px 0;color: #999">
											课程售价599元，如需考证（中级），售价799元。如需考高级证书，请咨询客服
										</div>
										<el-radio-group v-model="domain.is_cert" @input="isCertChangeEvent"
											:disabled="domain.is_cert_disabled">
											<el-radio label="是"></el-radio>
											<el-radio label="否"></el-radio>
										</el-radio-group>
									</el-form-item>
								
									<el-form-item v-if="domain.is_cert == '是'" :prop="'domains.' + index + '.id_card'"
										label="身份证号码"
										:rules="[{ required: true, message: '请输入身份证号码', trigger: ['blur', 'change'] },{ len:18,message: '请输入正确的身份证号码', trigger: ['blur', 'change'] }]">
										<div style="line-height: 1.4;margin: 12px 0;color: #999">
											为登记信息，方便后续大家考试，请各位老师填写身份证号
										</div>
										<el-input v-model="domain.id_card" placeholder="请输入身份证号码"></el-input>
									</el-form-item>
									
									<el-form-item  label="邮寄地址" required>
										
										<el-col :span="24">
											<div style="line-height: 1.4;color: #999">
												为方便后续给大家寄送图书<span v-if="domain.is_cert == '是'">及证书</span>，请各位老师填写真实收件地址
											</div>
										  <el-form-item :prop="'domains.' + index + '.pca'" :rules="[{ required: true, message: '请选择省市区', trigger: ['blur', 'change']}]">
											<el-cascader placeholder="请选择省市区" :options="options" v-model="domain.pca"  :props="{label:'name',value:'name',children:'children' }" filterable ></el-cascader>
										  </el-form-item>
										</el-col>
										<el-col :span="24">
										  <el-form-item :prop="'domains.' + index + '.address'" :rules="[{ required: true, message: '请输入详情地址', trigger: ['blur', 'change']}]">
											<el-input v-model="domain.address" placeholder="请输入详细地址"></el-input>
										  </el-form-item>
										</el-col>
									</el-form-item> 
								
								</div>
								
								
								<!-- 第七届组织行为学课程教学研讨会-->
								<div v-if="id == 't_b5d8fef104dd4cefb3649fcf6548076d' && domain.is_show_more">
								
									<el-form-item :prop="'domains.' + index + '.check_in_date'" label="报到日期"
										:rules="[{ required: true, message: '请选择报到日期', trigger: ['blur', 'change'] }]">
										<el-radio-group v-model="domain.check_in_date">
											<el-radio label="5月9日"></el-radio>
											<el-radio label="5月10日"></el-radio>
											<el-radio label="其他"></el-radio>
										</el-radio-group>
									</el-form-item>
									
									<el-form-item v-if="domain.check_in_date == '其他'"
										:prop="'domains.' + index + '.check_in_date_other'" label="其他报到日期"
										:rules="[ { required: true, message: '请输入其他报到日期', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.check_in_date_other"
											placeholder="请输入其他报到日期"></el-input>
									</el-form-item>
									
									
									<el-form-item :prop="'domains.' + index + '.stay_type'" label="住宿" :rules="[{ required: true, message: '请选择住宿方式', trigger: 'change' }]">
										<el-radio-group v-model="domain.stay_type">
											<el-radio label="会务组代行预订"></el-radio>
											<el-radio label="自行安排"></el-radio>
										 </el-radio-group>
									</el-form-item>
									
			
									<el-form-item v-if="domain.stay_type == '会务组代行预订'" :prop="'domains.' + index + '.room_type_before'" label="酒店房型"
										:rules="[{ required: true, message: '请选择您对入住房型的需求', trigger: ['blur', 'change'] }]">
										
										<div style="line-height: 1.4;margin: 12px 0;color: #999">
											◆ 西溪灵隐智选假日酒店，地址：浙江省杭州市西湖区西溪路616号<br>
											协议价：380元/人（商务大床/标间可选、含早餐）<br>
										</div>
										
										<el-radio-group v-model="domain.room_type_before">
											<el-radio label="大床房"></el-radio>
											<el-radio label="标准间"></el-radio>
											<el-radio label="其他"></el-radio>
										</el-radio-group>
									</el-form-item>
																	
									
									<el-form-item v-if="domain.room_type_before == '其他'"
										:prop="'domains.' + index + '.room_type_other'" label="其他入住房型的需求"
										:rules="[ { required: true, message: '请输入其他入住房型的需求', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.room_type_other"
											placeholder="请输入其他入住房型的需求"></el-input>
									</el-form-item>
																	
									<el-form-item v-if="domain.room_type_before"
										:prop="'domains.' + index + '.room_type'" label="入住方式"
										:rules="[{ required: true, message: '请选择入住方式', trigger: ['blur', 'change'] }]">
										<el-radio-group v-model="domain.room_type">
											<el-radio label="单人入住"></el-radio>
											<el-radio label="与指定人员拼房"></el-radio>
											<el-radio label="会务组随机拼房"></el-radio>
										</el-radio-group>
									</el-form-item>
																	
																	
									<el-form-item v-if="domain.room_type == '与指定人员拼房'"
										:prop="'domains.' + index + '.room_share_with'" label="合住人姓名"
										:rules="[ { required: true, message: '请输入合住人姓名', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.room_share_with" placeholder="请输入合住人姓名"></el-input>
									</el-form-item>
									
									<el-form-item v-if="domain.room_type_before" :prop="'domains.' + index + '.stay_days'" label="入住天数" :rules="[{ required: true, message: '请选择入住方式', trigger: ['blur', 'change'] }]">
										<el-radio-group v-model="domain.stay_days">
											<el-radio label="1天"></el-radio>
											<el-radio label="2天"></el-radio>
											<el-radio label="3天"></el-radio>
											<el-radio label="其他"></el-radio>
										</el-radio-group>
									</el-form-item>
									
									<el-form-item v-if="domain.stay_days == '其他'"
										:prop="'domains.' + index + '.stay_days_other'" label="其他入住天数"
										:rules="[ { required: true, message: '请输入其他入住天数', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.stay_days_other" placeholder="请输入其他入住天数"></el-input>
									</el-form-item>
								
								</div>
								
								
								<!-- 职业院校机械制图课程教学改革研讨会暨教师能力提升特训营的通知 -->
								<div v-if="id == 't_27423f35fe694b83a9457f5f173e15a0' && domain.is_show_more">
								
									<el-form-item :prop="'domains.' + index + '.check_in_date'" label="报到日期"
										:rules="[{ required: true, message: '请选择报到日期', trigger: ['blur', 'change'] }]">
										<el-radio-group v-model="domain.check_in_date">
											<el-radio label="5月9日"></el-radio>
											<el-radio label="5月10日"></el-radio>
											<el-radio label="其他"></el-radio>
										</el-radio-group>
									</el-form-item>
									
									<el-form-item v-if="domain.check_in_date == '其他'"
										:prop="'domains.' + index + '.check_in_date_other'" label="其他报到日期"
										:rules="[ { required: true, message: '请输入其他报到日期', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.check_in_date_other"
											placeholder="请输入其他报到日期"></el-input>
									</el-form-item>
									
									
									<el-form-item :prop="'domains.' + index + '.stay_type'" label="住宿" :rules="[{ required: true, message: '请选择住宿方式', trigger: 'change' }]">
										<el-radio-group v-model="domain.stay_type">
											<el-radio label="会务组代行预订"></el-radio>
											<el-radio label="自行安排"></el-radio>
										 </el-radio-group>
									</el-form-item>
									
											
									<el-form-item v-if="domain.stay_type == '会务组代行预订'" :prop="'domains.' + index + '.room_type_before'" label="酒店房型"
										:rules="[{ required: true, message: '请选择您对入住房型的需求', trigger: ['blur', 'change'] }]">
										
										<div style="line-height: 1.4;margin: 12px 0;color: #999">
											◆ 江苏省南京市世纪缘湖滨花园酒店，地址：南京市玄武区太平门阳光路3号<br>
											协议价：360元/人（商务大床/标间可选、含早餐）<br>
										</div>
										
										<el-radio-group v-model="domain.room_type_before">
											<el-radio label="大床房"></el-radio>
											<el-radio label="标准间"></el-radio>
											<el-radio label="其他"></el-radio>
										</el-radio-group>
									</el-form-item>
																	
									
									<el-form-item v-if="domain.room_type_before == '其他'"
										:prop="'domains.' + index + '.room_type_other'" label="其他入住房型的需求"
										:rules="[ { required: true, message: '请输入其他入住房型的需求', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.room_type_other"
											placeholder="请输入其他入住房型的需求"></el-input>
									</el-form-item>
																	
									<el-form-item v-if="domain.room_type_before"
										:prop="'domains.' + index + '.room_type'" label="入住方式"
										:rules="[{ required: true, message: '请选择入住方式', trigger: ['blur', 'change'] }]">
										<el-radio-group v-model="domain.room_type">
											<el-radio label="单人入住"></el-radio>
											<el-radio label="与指定人员拼房"></el-radio>
											<el-radio label="会务组随机拼房"></el-radio>
										</el-radio-group>
									</el-form-item>
																	
																	
									<el-form-item v-if="domain.room_type == '与指定人员拼房'"
										:prop="'domains.' + index + '.room_share_with'" label="合住人姓名"
										:rules="[ { required: true, message: '请输入合住人姓名', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.room_share_with" placeholder="请输入合住人姓名"></el-input>
									</el-form-item>
									
									<el-form-item v-if="domain.room_type_before" :prop="'domains.' + index + '.stay_days'" label="入住天数" :rules="[{ required: true, message: '请选择入住方式', trigger: ['blur', 'change'] }]">
										<el-radio-group v-model="domain.stay_days">
											<el-radio label="1天"></el-radio>
											<el-radio label="2天"></el-radio>
											<el-radio label="3天"></el-radio>
											<el-radio label="其他"></el-radio>
										</el-radio-group>
									</el-form-item>
									
									<el-form-item v-if="domain.stay_days == '其他'"
										:prop="'domains.' + index + '.stay_days_other'" label="其他入住天数"
										:rules="[ { required: true, message: '请输入其他入住天数', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.stay_days_other" placeholder="请输入其他入住天数"></el-input>
									</el-form-item>
								
								</div>
								
								
								<!-- 案例研究 -->
								<div v-if="id == 't_f6c67deb3ffe4346a601e7f28d577dd9' && domain.is_show_more">
								
									<el-form-item :prop="'domains.' + index + '.check_in_date'" label="报到日期"
										:rules="[{ required: true, message: '请选择报到日期', trigger: ['blur', 'change'] }]">
										<el-radio-group v-model="domain.check_in_date">
											<el-radio label="4月25日"></el-radio>
											<el-radio label="4月26日"></el-radio>
											<el-radio label="其他"></el-radio>
										</el-radio-group>
									</el-form-item>
									
									<el-form-item v-if="domain.check_in_date == '其他'"
										:prop="'domains.' + index + '.check_in_date_other'" label="其他报到日期"
										:rules="[ { required: true, message: '请输入其他报到日期', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.check_in_date_other"
											placeholder="请输入其他报到日期"></el-input>
									</el-form-item>
									
									
									<el-form-item :prop="'domains.' + index + '.stay_type'" label="住宿" :rules="[{ required: true, message: '请选择住宿方式', trigger: 'change' }]">
										<div style="line-height: 1.4;margin: 12px 0;color: #999">
											协议酒店已订满，请大家自行安排住宿
										</div>
										<!-- <el-radio-group v-model="domain.stay_type">
											<el-radio label="自行安排"></el-radio>
											<el-radio label="会务组代行预订" disabled></el-radio>
										 </el-radio-group> -->
									</el-form-item>
									
											
									<!-- 
									<el-form-item v-if="domain.stay_type == '会务组代行预订'" :prop="'domains.' + index + '.room_type_before'" label="酒店房型"
										:rules="[{ required: true, message: '请选择您对入住房型的需求', trigger: ['blur', 'change'] }]">
										
										<div style="line-height: 1.4;margin: 12px 0;color: #999">
											◆ 上海建国宾馆大堂，地址：上海市漕溪北路439号<br>
											协议价：380元/人（商务大床/标间可选、含早餐）<br>
										</div>
										
										<el-radio-group v-model="domain.room_type_before">
											<el-radio label="大床房"></el-radio>
											<el-radio label="标准间"></el-radio>
											<el-radio label="其他"></el-radio>
										</el-radio-group>
									</el-form-item>
																	
									
									<el-form-item v-if="domain.room_type_before == '其他'"
										:prop="'domains.' + index + '.room_type_other'" label="其他入住房型的需求"
										:rules="[ { required: true, message: '请输入其他入住房型的需求', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.room_type_other"
											placeholder="请输入其他入住房型的需求"></el-input>
									</el-form-item>
																	
									<el-form-item v-if="domain.room_type_before"
										:prop="'domains.' + index + '.room_type'" label="入住方式"
										:rules="[{ required: true, message: '请选择入住方式', trigger: ['blur', 'change'] }]">
										<el-radio-group v-model="domain.room_type">
											<el-radio label="单人入住"></el-radio>
											<el-radio label="与指定人员拼房"></el-radio>
											<el-radio label="会务组随机拼房"></el-radio>
										</el-radio-group>
									</el-form-item>
																	
																	
									<el-form-item v-if="domain.room_type == '与指定人员拼房'"
										:prop="'domains.' + index + '.room_share_with'" label="合住人姓名"
										:rules="[ { required: true, message: '请输入合住人姓名', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.room_share_with" placeholder="请输入合住人姓名"></el-input>
									</el-form-item>
									
									<el-form-item v-if="domain.room_type_before" :prop="'domains.' + index + '.stay_days'" label="入住天数" :rules="[{ required: true, message: '请选择入住方式', trigger: ['blur', 'change'] }]">
										<el-radio-group v-model="domain.stay_days">
											<el-radio label="1天"></el-radio>
											<el-radio label="2天"></el-radio>
											<el-radio label="3天"></el-radio>
											<el-radio label="其他"></el-radio>
										</el-radio-group>
									</el-form-item>
									
									<el-form-item v-if="domain.stay_days == '其他'"
										:prop="'domains.' + index + '.stay_days_other'" label="其他入住天数"
										:rules="[ { required: true, message: '请输入其他入住天数', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.stay_days_other" placeholder="请输入其他入住天数"></el-input>
									</el-form-item> 
									
									-->
								
								</div>
								
								
								<!-- AI赋能教育教学：人工智能专项技能培训-->
								<div v-if="id == 't_c4fbb69f9b934b889e6c1a22ab5696dd'">
								

									<el-form-item :prop="'domains.' + index + '.id_card'"
										label="身份证号码"
										:rules="[{ required: true, message: '请输入身份证号码', trigger: ['blur', 'change'] },{ len:18,message: '请输入正确的身份证号码', trigger: ['blur', 'change'] }]">
										<div style="line-height: 1.4;margin: 12px 0;color: #999">
											为登记信息，方便后续大家考试，请各位老师填写身份证号
										</div>
										<el-input v-model="domain.id_card" placeholder="请输入身份证号码"></el-input>
									</el-form-item>
									
									<el-form-item  label="邮寄地址" required>
										
										<el-col :span="24">
											<div style="line-height: 1.4;color: #999">
												为方便后续给大家寄送证书，请各位老师填写真实收件地址
											</div>
										  <el-form-item :prop="'domains.' + index + '.pca'" :rules="[{ required: true, message: '请选择省市区', trigger: ['blur', 'change']}]">
											<el-cascader placeholder="请选择省市区" :options="options" v-model="domain.pca"  :props="{label:'name',value:'name',children:'children' }" filterable ></el-cascader>
										  </el-form-item>
										</el-col>
										<el-col :span="24">
										  <el-form-item :prop="'domains.' + index + '.address'" :rules="[{ required: true, message: '请输入详情地址', trigger: ['blur', 'change']}]">
											<el-input v-model="domain.address" placeholder="请输入详细地址"></el-input>
										  </el-form-item>
										</el-col>
									</el-form-item> 
								
								</div>
								
								
								<!-- 网络空间安全创新人才培养与课程建设教师研讨会 -->
								<div v-if="id == 't_db96373a571046028abbb81a022680b2' && domain.is_show_more">
								
									<el-form-item :prop="'domains.' + index + '.check_in_date'" label="报到日期"
										:rules="[{ required: true, message: '请选择报到日期', trigger: ['blur', 'change'] }]">

										<el-date-picker
										      v-model="domain.check_in_date"
										      type="date"
										      placeholder="请选择报到日期"
											  format="yyyy-MM-dd"
											  value-format="yyyy-MM-dd"
											   popper-class="stay_days"
											  :default-value="defaultStartDate"
											  :picker-options="pickerOptions">
										    </el-date-picker>
										
									</el-form-item>
									
									
									<el-form-item  v-if="detailData && detailData.has_visit == 1 && detailData.form_visit_label" :prop="'domains.' + index + '.is_visit'" :label="detailData.form_visit_label" :rules="[{ required: true, message: '请选择您是否参加参观考察', trigger: ['blur', 'change'] }]">
										<div style="line-height: 1.4;margin: 12px 0; color: #999;" v-html="detailData.form_visit_text"></div>
										<el-radio-group v-model="domain.is_visit">
											<el-radio label="是"></el-radio>
											<el-radio label="否"></el-radio>
										</el-radio-group>
									</el-form-item>
									

									
									<el-form-item :prop="'domains.' + index + '.stay_type'" label="住宿" :rules="[{ required: true, message: '请选择住宿方式', trigger: 'change' }]">
										<el-radio-group v-model="domain.stay_type">
											<el-radio label="会务组代行预订"></el-radio>
											<el-radio label="自行安排"></el-radio>
										 </el-radio-group>
									</el-form-item>
									
											
									<el-form-item v-if="domain.stay_type == '会务组代行预订'" :prop="'domains.' + index + '.room_type_before'" label="酒店房型"
										:rules="[{ required: true, message: '请选择您对入住房型的需求', trigger: ['blur', 'change'] }]">
										
										<div style="line-height: 1.4;margin: 12px 0;color: #999">
											◆ 南京珍宝假日饭店(南京江宁店)，地址：江苏省南京市双龙大道1706号，近地铁1号线百家湖站<br>
											协议价：大床房（含单早）360元/晚/间，标准间（含双早）360元/晚/间<br>
										</div>
										
										<el-radio-group v-model="domain.room_type_before">
											<el-radio label="大床房"></el-radio>
											<el-radio label="标准间"></el-radio>
											<el-radio label="其他"></el-radio>
										</el-radio-group>
									</el-form-item>
																	
									
									<el-form-item v-if="domain.room_type_before == '其他'"
										:prop="'domains.' + index + '.room_type_other'" label="其他入住房型的需求"
										:rules="[ { required: true, message: '请输入其他入住房型的需求', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.room_type_other"
											placeholder="请输入其他入住房型的需求"></el-input>
									</el-form-item>
																	
									<el-form-item v-if="domain.room_type_before"
										:prop="'domains.' + index + '.room_type'" label="入住方式"
										:rules="[{ required: true, message: '请选择入住方式', trigger: ['blur', 'change'] }]">
										<el-radio-group v-model="domain.room_type">
											<el-radio label="单人入住"></el-radio>
											<el-radio label="与指定人员拼房"></el-radio>
											<el-radio label="会务组随机拼房"></el-radio>
										</el-radio-group>
									</el-form-item>
																	
																	
									<el-form-item v-if="domain.room_type == '与指定人员拼房'"
										:prop="'domains.' + index + '.room_share_with'" label="合住人姓名"
										:rules="[ { required: true, message: '请输入合住人姓名', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.room_share_with" placeholder="请输入合住人姓名"></el-input>
									</el-form-item>
									
									<el-form-item v-if="domain.room_type_before" :prop="'domains.' + index + '.stay_days_arr'" label="入住及离店日期" :rules="[{ required: true, message: '请选择入住及离店日期', trigger: ['blur', 'change'] }]">
										<el-date-picker
										  v-model="domain.stay_days_arr"
										  type="daterange"
										  range-separator="至"
										  start-placeholder="入住日期"
										  end-placeholder="离店日期"
										  format="yyyy-MM-dd"
										  value-format="yyyy-MM-dd"
										  :default-value="defaultRangeDate"
										  :picker-options="pickerOptions"
										  popper-class="stay_days"
										  @change="stayDaysConfirmEvent($event,index)">
										</el-date-picker>
									</el-form-item>
									

								
								</div>
								
								
								<!-- 新时代高等职业教育人工智能通识课程建设研讨会 职教层次 -->
								<div v-if="id == 't_d72d1199783246b8a4f5e713e870ac63' && domain.is_show_more">
								
									<el-form-item :prop="'domains.' + index + '.check_in_date'" label="报到日期"
										:rules="[{ required: true, message: '请选择报到日期', trigger: ['blur', 'change'] }]">
								
										<el-date-picker
										      v-model="domain.check_in_date"
										      type="date"
										      placeholder="请选择报到日期"
											  format="yyyy-MM-dd"
											  value-format="yyyy-MM-dd"
											   popper-class="stay_days"
											  :default-value="defaultStartDate"
											  :picker-options="pickerOptions">
										    </el-date-picker>
										
									</el-form-item>
									
								
									
									<el-form-item :prop="'domains.' + index + '.stay_type'" label="住宿" :rules="[{ required: true, message: '请选择住宿方式', trigger: 'change' }]">
										<el-radio-group v-model="domain.stay_type">
											<el-radio label="会务组代行预订"></el-radio>
											<el-radio label="自行安排"></el-radio>
										 </el-radio-group>
									</el-form-item>
									
											
									<el-form-item v-if="domain.stay_type == '会务组代行预订'" :prop="'domains.' + index + '.room_type_before'" label="酒店房型"
										:rules="[{ required: true, message: '请选择您对入住房型的需求', trigger: ['blur', 'change'] }]">
										
										<div style="line-height: 1.4;margin: 12px 0;color: #999">
											西溪灵隐智选假日酒店，地址：浙江省杭州市西湖区西溪路616号<br>
											协议价：350元/间/晚（商务大床/标间可选、含早餐）<br>
										</div>
										
										<el-radio-group v-model="domain.room_type_before">
											<el-radio label="大床房"></el-radio>
											<el-radio label="标准间"></el-radio>
											<el-radio label="其他"></el-radio>
										</el-radio-group>
									</el-form-item>
																	
									
									<el-form-item v-if="domain.room_type_before == '其他'"
										:prop="'domains.' + index + '.room_type_other'" label="其他入住房型的需求"
										:rules="[ { required: true, message: '请输入其他入住房型的需求', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.room_type_other"
											placeholder="请输入其他入住房型的需求"></el-input>
									</el-form-item>
																	
									<el-form-item v-if="domain.room_type_before"
										:prop="'domains.' + index + '.room_type'" label="入住方式"
										:rules="[{ required: true, message: '请选择入住方式', trigger: ['blur', 'change'] }]">
										<el-radio-group v-model="domain.room_type">
											<el-radio label="单人入住"></el-radio>
											<el-radio label="与指定人员拼房"></el-radio>
											<el-radio label="会务组随机拼房"></el-radio>
										</el-radio-group>
									</el-form-item>
																	
																	
									<el-form-item v-if="domain.room_type == '与指定人员拼房'"
										:prop="'domains.' + index + '.room_share_with'" label="合住人姓名"
										:rules="[ { required: true, message: '请输入合住人姓名', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.room_share_with" placeholder="请输入合住人姓名"></el-input>
									</el-form-item>
									
									
									<el-form-item v-if="domain.room_type_before" :prop="'domains.' + index + '.stay_days_arr'" label="入住及离店日期" :rules="[{ required: true, message: '请选择入住及离店日期', trigger: ['blur', 'change'] }]">
										<el-date-picker
										  v-model="domain.stay_days_arr"
										  type="daterange"
										  range-separator="至"
										  start-placeholder="入住日期"
										  end-placeholder="离店日期"
										  format="yyyy-MM-dd"
										  value-format="yyyy-MM-dd"
										  :default-value="defaultRangeDate"
										  :picker-options="pickerOptions"
										  popper-class="stay_days"
										  @change="stayDaysConfirmEvent($event,index)">
										</el-date-picker>
									</el-form-item>
									
							
								</div>
								
								
								<!-- 2025年高等学校人工智能通识教育研讨会 高教层次 -->
								<!-- <div v-if="id == 't_c997fd495a1e47558da5bceb5b58f028' && domain.is_show_more">
								
									<el-form-item :prop="'domains.' + index + '.check_in_date'" label="报到日期"
										:rules="[{ required: true, message: '请选择报到日期', trigger: ['blur', 'change'] }]">
								
										<el-date-picker
										      v-model="domain.check_in_date"
										      type="date"
										      placeholder="请选择报到日期"
											  format="yyyy-MM-dd"
											  value-format="yyyy-MM-dd"
											   popper-class="stay_days"
											  :default-value="defaultStartDate"
											  :picker-options="pickerOptions">
										    </el-date-picker>
										
									</el-form-item>
									
								
									
									<el-form-item :prop="'domains.' + index + '.stay_type'" label="住宿" :rules="[{ required: true, message: '请选择住宿方式', trigger: 'change' }]">
										<el-radio-group v-model="domain.stay_type">
											<el-radio label="会务组代行预订"></el-radio>
											<el-radio label="自行安排"></el-radio>
										 </el-radio-group>
									</el-form-item>
									
											
									<el-form-item v-if="domain.stay_type == '会务组代行预订'" :prop="'domains.' + index + '.room_type_before'" label="酒店房型"
										:rules="[{ required: true, message: '请选择您对入住房型的需求', trigger: ['blur', 'change'] }]">
										
										<div style="line-height: 1.4;margin: 12px 0;color: #999">
											青岛华澜大酒店，地址：青岛市李沧区金水路171号<br>
											协议价：360元/间/晚（商务大床/标间可选，含早餐）<br>
										</div>
										
										<el-radio-group v-model="domain.room_type_before">
											<el-radio label="大床房"></el-radio>
											<el-radio label="标准间"></el-radio>
											<el-radio label="其他"></el-radio>
										</el-radio-group>
									</el-form-item>
																	
									
									<el-form-item v-if="domain.room_type_before == '其他'"
										:prop="'domains.' + index + '.room_type_other'" label="其他入住房型的需求"
										:rules="[ { required: true, message: '请输入其他入住房型的需求', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.room_type_other"
											placeholder="请输入其他入住房型的需求"></el-input>
									</el-form-item>
																	
									<el-form-item v-if="domain.room_type_before"
										:prop="'domains.' + index + '.room_type'" label="入住方式"
										:rules="[{ required: true, message: '请选择入住方式', trigger: ['blur', 'change'] }]">
										<el-radio-group v-model="domain.room_type">
											<el-radio label="单人入住"></el-radio>
											<el-radio label="与指定人员拼房"></el-radio>
											<el-radio label="会务组随机拼房"></el-radio>
										</el-radio-group>
									</el-form-item>
																	
																	
									<el-form-item v-if="domain.room_type == '与指定人员拼房'"
										:prop="'domains.' + index + '.room_share_with'" label="合住人姓名"
										:rules="[ { required: true, message: '请输入合住人姓名', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.room_share_with" placeholder="请输入合住人姓名"></el-input>
									</el-form-item>
									
									<el-form-item v-if="domain.room_type_before" :prop="'domains.' + index + '.stay_days_arr'" label="入住及离店日期" :rules="[{ required: true, message: '请选择入住及离店日期', trigger: ['blur', 'change'] }]">
										<el-date-picker
										  v-model="domain.stay_days_arr"
										  type="daterange"
										  range-separator="至"
										  start-placeholder="入住日期"
										  end-placeholder="离店日期"
										  format="yyyy-MM-dd"
										  value-format="yyyy-MM-dd"
										  :default-value="defaultRangeDate"
										  :picker-options="pickerOptions"
										  popper-class="stay_days"
										  @change="stayDaysConfirmEvent($event,index)">
										</el-date-picker>
									</el-form-item>

								</div> -->
								
								
								
								<!-- 中国机械工业教育协会应用型本科机械工程专业委员会2025年工作会议 -->
								<div v-else-if="id == 't_8531640d53044cd1826970d2506a3933' && domain.is_show_more">
								
									<el-form-item :prop="'domains.' + index + '.check_in_date'" label="报到日期"
										:rules="[{ required: true, message: '请选择报到日期', trigger: ['blur', 'change'] }]">
								
										<el-date-picker
										      v-model="domain.check_in_date"
										      type="date"
										      placeholder="请选择报到日期"
											  format="yyyy-MM-dd"
											  value-format="yyyy-MM-dd"
											   popper-class="stay_days"
											  :default-value="defaultStartDate"
											  :picker-options="pickerOptions">
										</el-date-picker>
										
									</el-form-item>
									
								
									
									<el-form-item :prop="'domains.' + index + '.stay_type'" label="住宿" :rules="[{ required: true, message: '请选择住宿方式', trigger: 'change' }]">
										<el-radio-group v-model="domain.stay_type">
											<el-radio label="会务组代行预订"></el-radio>
											<el-radio label="自行安排"></el-radio>
										 </el-radio-group>
									</el-form-item>
									
											
									<el-form-item v-if="domain.stay_type == '会务组代行预订'" :prop="'domains.' + index + '.room_type_before'" label="酒店房型"
										:rules="[{ required: true, message: '请选择您对入住房型的需求', trigger: ['blur', 'change'] }]">
										
										<div style="line-height: 1.4;margin: 12px 0;color: #999">
											江苏连云港市金陵云台宾馆，地址：连云港市海州区苍梧路27号<br>
											协议价：360元/晚/间（单间/标间可选，含单早）<br>
										</div>
										
										<el-radio-group v-model="domain.room_type_before">
											<el-radio label="大床房"></el-radio>
											<el-radio label="标准间"></el-radio>
											<el-radio label="其他"></el-radio>
										</el-radio-group>
									</el-form-item>
																	
									
									<el-form-item v-if="domain.room_type_before == '其他'"
										:prop="'domains.' + index + '.room_type_other'" label="其他入住房型的需求"
										:rules="[ { required: true, message: '请输入其他入住房型的需求', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.room_type_other"
											placeholder="请输入其他入住房型的需求"></el-input>
									</el-form-item>
																	
									<el-form-item v-if="domain.room_type_before"
										:prop="'domains.' + index + '.room_type'" label="入住方式"
										:rules="[{ required: true, message: '请选择入住方式', trigger: ['blur', 'change'] }]">
										<el-radio-group v-model="domain.room_type">
											<el-radio label="单人入住"></el-radio>
											<el-radio label="与指定人员拼房"></el-radio>
											<el-radio label="会务组随机拼房"></el-radio>
										</el-radio-group>
									</el-form-item>
																	
																	
									<el-form-item v-if="domain.room_type == '与指定人员拼房'"
										:prop="'domains.' + index + '.room_share_with'" label="合住人姓名"
										:rules="[ { required: true, message: '请输入合住人姓名', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.room_share_with" placeholder="请输入合住人姓名"></el-input>
									</el-form-item>
									
									<el-form-item v-if="domain.room_type_before" :prop="'domains.' + index + '.stay_days_arr'" label="入住及离店日期" :rules="[{ required: true, message: '请选择入住及离店日期', trigger: ['blur', 'change'] }]">
										<el-date-picker
										  v-model="domain.stay_days_arr"
										  type="daterange"
										  range-separator="至"
										  start-placeholder="入住日期"
										  end-placeholder="离店日期"
										  format="yyyy-MM-dd"
										  value-format="yyyy-MM-dd"
										  :default-value="defaultRangeDate"
										  :picker-options="pickerOptions"
										  popper-class="stay_days"
										  @change="stayDaysConfirmEvent($event,index)">
										</el-date-picker>
									</el-form-item>
								
								</div>
								
								
								<!-- “AI赋能机械行业教育教学”专题培训 -->
								<div v-else-if="id == 't_0348513a35094590bbb039c90e0f9c57'" >
								
									<el-form-item :prop="'domains.' + index + '.is_cert'" :label="detailData.form_cert_label"
										:rules="[{ required: true, message: '请选择是否考证', trigger: ['blur', 'change'] }]">
										<div style="line-height: 1.4;margin-bottom: 12px;color: #999; text-align: justify;">
											<span v-if="inviter">您是中国机械行业教育教学名师/先进工作者，本次培训费免费。如需考证，可自愿付费参加考试，考试费500元。</span>
											<span v-if="!inviter">课程售价299元，如需考证，可自愿付费参加考试，考试费500元。</span>
										</div>
										<el-radio-group v-model="domain.is_cert" @input="isCertChangeEvent"
											:disabled="domain.is_cert_disabled">
											<el-radio label="是"></el-radio>
											<el-radio label="否"></el-radio>
										</el-radio-group>
									</el-form-item>
								
									<el-form-item v-if="domain.is_cert == '是'" :prop="'domains.' + index + '.id_card'"
										label="身份证号码"
										:rules="[{ required: true, message: '请输入身份证号码', trigger: ['blur', 'change'] },{ len:18,message: '请输入正确的身份证号码', trigger: ['blur', 'change'] }]">
										<div v-if="detailData.form_id_card_text" v-html="detailData.form_id_card_text" style="line-height: 1.4;margin: 12px 0;color: #999"></div>
										<el-input v-model="domain.id_card" placeholder="请输入身份证号码"></el-input>
									</el-form-item>
									
									<el-form-item v-if="domain.is_cert == '是'" label="邮寄地址" required>
										
										<el-col :span="24">
										  <div v-if="detailData.form_address_text" v-html="detailData.form_address_text"  style="line-height: 1.4;color: #999"></div>
										  
										  <el-form-item :prop="'domains.' + index + '.pca'" :rules="[{ required: true, message: '请选择省市区', trigger: ['blur', 'change']}]">
											<el-cascader placeholder="请选择省市区" :options="options" v-model="domain.pca"  :props="{label:'name',value:'name',children:'children' }" filterable ></el-cascader>
										  </el-form-item>
										</el-col>
										<el-col :span="24">
										  <el-form-item :prop="'domains.' + index + '.address'" :rules="[{ required: true, message: '请输入详情地址', trigger: ['blur', 'change']}]">
											<el-input v-model="domain.address" placeholder="请输入详细地址"></el-input>
										  </el-form-item>
										</el-col>
									</el-form-item> 
								
								</div>
								
								
								

								
								<!-- 其他特训营-->
								<div v-else>
									
									<!-- 非纯线上 -->
									<div v-if="domain.is_show_more">
										
									<!-- 报到日期  具体到几点-->
									<el-form-item v-if="detailData && detailData.has_arrival_date == 1 " :prop="'domains.' + index + '.check_in_date'" label="报到日期" :rules="[{ required: true, message: '请选择报到日期', trigger: ['blur', 'change'] }]">
										<el-date-picker
										      v-model="domain.check_in_date"
										      type="datetime"
										      placeholder="请选择报到日期"
											  format="yyyy-MM-dd HH:mm:ss"
											  value-format="yyyy-MM-dd HH:mm:ss"
											   popper-class="stay_days"
											  :default-value="defaultStartDate2"
											  :picker-options="pickerOptions">
										</el-date-picker>
									</el-form-item>
									
									<!-- 会场报到车牌号码 非报到日-->
									<el-form-item v-if="domain.check_in_date && !isSameDay(domain.check_in_date,detailData.arrival_at) && detailData.has_arrival_plate_number == 1"
										:prop="'domains.' + index + '.check_in_plate_number'" label="车牌号码">
										<el-input v-model="domain.check_in_plate_number" placeholder="如自驾前往会场，请填写车牌号码"></el-input>
									</el-form-item>
									
									<!-- 用餐情况（单选）报到日晚餐 -->
									<el-form-item  v-if="detailData && detailData.has_dine == 1 && detailData.form_dine_label" :prop="'domains.' + index + '.is_dine'" :label="detailData.form_dine_label" :rules="[{ required: true, message: '请选择是否用餐', trigger: ['blur', 'change'] }]">
										<div style="line-height: 1.4;margin: 12px 0; color: #999;" v-if="detailData.form_dine_text" v-html="detailData.form_dine_text"></div>
										<el-radio-group v-model="domain.is_dine">
											<el-radio label="是"></el-radio>
											<el-radio label="否"></el-radio>
										</el-radio-group>
									</el-form-item>
									
									<!-- 用餐需求（多选） -->
									<el-form-item  v-if="detailData && detailData.has_dine_checkbox == 1 && detailData.form_dine_items && detailData.form_dine_items.length>0" :prop="'domains.' + index + '.dine_items'" label="用餐需求" :rules="[{ required: true, message: '请选择', trigger: ['blur', 'change'] }]">
										<el-checkbox-group v-model="domain.dine_items_arr" @change="dineCheckboxGroupChange($event,index)">
											<el-checkbox v-for="(tem,dex) in detailData.form_dine_items" :label="tem" ></el-checkbox>
										</el-checkbox-group>
									</el-form-item>
									
									<!-- 是否参访 -->
									<el-form-item  v-if="detailData && detailData.has_visit == 1 && detailData.form_visit_label" :prop="'domains.' + index + '.is_visit'" :label="detailData.form_visit_label" :rules="[{ required: true, message: '请选择您是否参加参观考察', trigger: ['blur', 'change'] }]">
										<div style="line-height: 1.4;margin: 12px 0; color: #999;" v-if="detailData.form_visit_text" v-html="detailData.form_visit_text"></div>
										<el-radio-group v-model="domain.is_visit" v-if="detailData.has_visit_plate_number == 0">
											<el-radio label="是"></el-radio>
											<el-radio label="否"></el-radio>
										</el-radio-group>
										
										<el-radio-group @change="isVisitChangeEvent($event,index)"   v-model="domain.is_visit" v-if="detailData.has_visit_plate_number == 1">
											<el-radio label="是（统一安排）"></el-radio>
											<el-radio label="是（自行前往）"></el-radio>
											<el-radio label="否"></el-radio>
										</el-radio-group>
									</el-form-item>
									
									<!-- 参访车牌号码 -->
									<el-form-item v-if="domain.is_visit && domain.is_visit =='是（自行前往）'" :prop="'domains.' + index + '.visit_plate_number'" label="车牌号码">
										<el-input v-model="domain.visit_plate_number" placeholder="如自驾前往参访地，请填写车牌号码"></el-input>
									</el-form-item>
									
									<!-- 身份证号码特殊处理 2026年（第六届）高校PLC及运动控制类课程教学研讨与教师培训会 -->
									<el-form-item v-if="id=='t_5b5588fa47ff4edab4217cf785d57bc7' && detailData &&  detailData.has_id_card == 1 && domain.is_visit && domain.is_visit =='是'" :prop="'domains.' + index + '.id_card'"
										label="身份证号码"
										:rules="[{ required: true, message: '请输入身份证号码', trigger: ['blur', 'change'] },{ len:18,message: '请输入正确的身份证号码', trigger: ['blur', 'change'] }]">
										<div v-if="detailData.form_id_card_text" v-html="detailData.form_id_card_text" style="line-height: 1.4;margin: 12px 0;color: #999"></div>
										<el-input v-model="domain.id_card" placeholder="请输入身份证号码"></el-input>
									</el-form-item>
									

									<el-form-item v-if="id == 't_e4d75e6e62d94c17896d2312958bcd18'" label="酒店相关信息" >
										<div style="width: 100%; line-height: 1.5; margin-bottom: 20upx; text-align: justify; color: #999;">
											暑期房源紧张，请各位老师自行联系酒店预定房间<br/>
											推荐住宿酒店：京滨饭店  预订部电话 010-68580115<br/>  
											预定时请报“机械工业信息研究院”享受协议价518元/晚
										</div>
									</el-form-item>
									
									<el-form-item v-if="id == 't_7ac25832e5d84276b62f1cb32dd1e3a9'" label="酒店相关信息" >
										<div style="width: 100%; line-height: 1.5; margin-bottom: 20upx; text-align: justify; color: #999;">
											会议酒店-广州南国酒店房源已订满，请您自行联系周边其他酒店住宿。<br>
											
											1、广州维多利酒店珠江新城店（天河区黄埔大道西106号） ，胡经理18022329218，报“电力电子与电力传动学科教学研讨会”，享受优惠价 450元/晚<br>
											
											2、广州珠江新城骑士物语酒店（天河区员村街道员村一横路7号），李经理13580327383，报“电力电子与电力传动学科教学研讨会”，享受优惠价 450元/晚
											
										</div>
									</el-form-item>
									
									<el-form-item v-if="detailData && detailData.has_hotel == 1 && detailData.form_hotel_items" :prop="'domains.' + index + '.stay_type'" label="住宿" :rules="[{ required: true, message: '请选择住宿类型', trigger: 'change' }]">
										<el-radio-group v-model="domain.stay_type" @input="stayTypeChange($event,index)">
											<el-radio label="会务组代行预订"></el-radio>
											<el-radio label="自行安排"></el-radio>
										 </el-radio-group>
										 <div style="width: 260px; font-size: 12px; text-align: left;color: #C93A2E; margin-top: -18px; margin-left: 24px;">
											 具体以当日房价为准
										 </div>
									</el-form-item>
									

									<el-form-item v-if="detailData.form_hotel_items && domain.stay_type=='会务组代行预订'" :prop="'domains.' + index + '.hotel'" label="酒店" :rules="[{ required: true, message: '请选择您入住的酒店', trigger: ['blur', 'change'] }]">
										<el-radio-group v-model="domain.hotel">
											<el-radio :label="tem" v-for="(tem,dex) in detailData.form_hotel_items" v-if="id != 't_214d06e2f1af4233b286e9e09df1efb7'"></el-radio>
											<el-radio :label="tem" v-for="(tem,dex) in detailData.form_hotel_items" v-if="id == 't_214d06e2f1af4233b286e9e09df1efb7'" :disabled="tem.indexOf('创远城市中心酒店') !=-1 ? false :true">{{tem}}<span v-if="tem.indexOf('创远城市中心酒店') ==-1">（已满房）</span></el-radio>
										</el-radio-group>
									</el-form-item>
									
									
									<!-- 2026高校自动化专业教学研讨及教师研修会议 -->
									<el-form-item v-if="id == 't_214d06e2f1af4233b286e9e09df1efb7' && domain.hotel.indexOf('创远城市中心酒店') !=-1 " label="酒店相关信息" >
										<div style="display: flex; flex-direction: column; width: 100%; line-height: 1.5; margin-bottom: 5px; text-align: justify; color: #999;">
											<div>创远城市中心酒店位于皇冠假日酒店的B座，分为单层房型、复式房型，房型随机安排。复式房型照片如下：</div>
											<div style=" width: 100%; display: flex;  flex-direction: row; margin-top: 5px;">
												<div v-for="(tem,dex) in hotel_image_list" style="display: inline-flex; width: 100px; height: 100px; margin-right: 5px; position: relative;" >
													<el-image
													    fit="fill"
														style="width: 100px; height: 100px;"
													    :src="tem" 
													    :preview-src-list="hotel_image_list">
													  </el-image>
													  
													  <i class="el-icon-full-screen" style="position: absolute; right: 3px; bottom:3px ; color: #fff;"></i>
												</div>
											</div>
										</div>
									</el-form-item>
									
									<el-form-item v-if="domain.hotel" :prop="'domains.' + index + '.room_type_before'" label="酒店房型"
										:rules="[{ required: true, message: '请选择您对入住房型的需求', trigger: ['blur', 'change'] }]">
										<el-radio-group v-model="domain.room_type_before">
											<el-radio label="大床房"></el-radio>
											<el-radio label="标准间"></el-radio>
											<!-- <el-radio label="其他"></el-radio> -->
										</el-radio-group>
									</el-form-item>
									
									<el-form-item v-if="domain.room_type_before == '其他'"
										:prop="'domains.' + index + '.room_type_other'" label="其他入住房型的需求"
										:rules="[ { required: true, message: '请输入其他入住房型的需求', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.room_type_other"
											placeholder="请输入其他入住房型的需求"></el-input>
									</el-form-item>
									
									<el-form-item v-if="domain.room_type_before"
										:prop="'domains.' + index + '.room_type'" label="入住方式"
										:rules="[{ required: true, message: '请选择入住方式', trigger: ['blur', 'change'] }]">
										<el-radio-group v-model="domain.room_type">
											<el-radio label="单人入住"></el-radio>
											<el-radio label="与指定人员拼房"></el-radio>
											<!-- <el-radio label="会务组随机拼房"></el-radio> -->
										</el-radio-group>
									</el-form-item>
															
									<el-form-item v-if="domain.room_type == '与指定人员拼房'"
										:prop="'domains.' + index + '.room_share_with'" label="合住人姓名"
										:rules="[ { required: true, message: '请输入合住人姓名', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.room_share_with" placeholder="请输入合住人姓名"></el-input>
									</el-form-item>


									<el-form-item v-if="domain.room_type_before" :prop="'domains.' + index + '.stay_days_arr'" label="入住及离店日期" :rules="[{ required: true, message: '请选择入住及离店日期', trigger: ['blur', 'change'] }]">
										<el-date-picker
										  v-model="domain.stay_days_arr"
										  type="daterange"
										  range-separator="至"
										  start-placeholder="入住日期"
										  end-placeholder="离店日期"
										  format="yyyy-MM-dd"
										  value-format="yyyy-MM-dd"
										  :default-value="defaultRangeDate"
										  :picker-options="pickerOptions"
										  popper-class="stay_days"
										  @change="stayDaysConfirmEvent($event,index)">
										</el-date-picker>
									</el-form-item>
									
									</div>
									
									<!-- 是否考证 -->
									<el-form-item  v-if="detailData && detailData.has_cert == 1 && detailData.form_cert_label"  :prop="'domains.' + index + '.is_cert'" :label="detailData.form_cert_label"
										:rules="[{ required: true, message: '请选择是否考证', trigger: ['blur', 'change'] }]">
										<el-radio-group v-model="domain.is_cert" @input="isCertChangeEvent"
											:disabled="domain.is_cert_disabled">
												<el-radio label="是" v-if="detailData.cert_fee>0">是 (考证费 {{detailData.cert_fee}} 元)</el-radio>
												<el-radio label="是" v-if="detailData.cert_fee==0">是 (考证免费)</el-radio>
												<el-radio label="否"></el-radio>
										</el-radio-group>
									</el-form-item>
									
									<!-- 身份证号码 -->
									<el-form-item v-if="id!='t_5b5588fa47ff4edab4217cf785d57bc7' && detailData &&  ((detailData.has_cert == 1 && domain.is_cert == '是') || (detailData.has_cert == 0 && detailData.has_id_card == 1))" :prop="'domains.' + index + '.id_card'"
										label="身份证号码"
										:rules="[{ required: true, message: '请输入身份证号码', trigger: ['blur', 'change'] },{ len:18,message: '请输入正确的身份证号码', trigger: ['blur', 'change'] }]">
										<div v-if="detailData.form_id_card_text" v-html="detailData.form_id_card_text" style="line-height: 1.4;margin: 12px 0;color: #999"></div>
										<el-input v-model="domain.id_card" placeholder="请输入身份证号码"></el-input>
									</el-form-item>
									
									<!-- 联系地址 -->
									<el-form-item v-if="detailData &&  ((detailData.has_cert == 1 && domain.is_cert == '是') || (detailData.has_cert == 0 && detailData.has_address == 1))" label="邮寄地址" required>
										
										<el-col :span="24">
										  <div v-if="detailData.form_address_text" v-html="detailData.form_address_text"  style="line-height: 1.4;color: #999;"></div>
										  
										  <el-form-item :prop="'domains.' + index + '.pca'" :rules="[{ required: true, message: '请选择省市区', trigger: ['blur', 'change']}]">
											<el-cascader placeholder="请选择省市区" :options="options" v-model="domain.pca"  :props="{label:'name',value:'name',children:'children' }" filterable ></el-cascader>
										  </el-form-item>
										</el-col>
										<el-col :span="24">
										  <el-form-item :prop="'domains.' + index + '.address'" :rules="[{ required: true, message: '请输入详情地址', trigger: ['blur', 'change']}]">
											<el-input v-model="domain.address" placeholder="请输入详细地址"></el-input>
										  </el-form-item>
										</el-col>
									</el-form-item> 
									
									<!-- 图片采集 -->
									<el-form-item :label="detailData.form_image_label" :prop="'domains.' + index + '.img'" v-if="detailData &&  ((detailData.has_cert == 1 && domain.is_cert == '是') || (detailData.has_cert == 0 && detailData.has_image == 1))">
										
										<div v-if="detailData.form_image_text" v-html="detailData.form_image_text"  style="line-height: 1.4;color: #999; margin-top: 10px; margin-bottom: -5px;"></div>
										<div class="pic2_box">
											<el-upload
												v-if="!domain.img_list || (domain.img_list && domain.img_list.length < detailData.form_image_limit)"
												:file-list="domain.img_list"
												accept=".jpg,.jpeg,.png,.bmp"
												action="#"
												drag
												multiple
												:auto-upload="false"
												:show-file-list="false"
												:limit="detailData.form_image_limit"
												:on-exceed="(files, fileList) => handleImgExceed2(files, fileList,index)"
												:on-change="(file, fileList) => handleImgChange2(file, fileList, index)"
											>
												<i class="el-icon-plus" style="margin-right: 8px;"></i>
												请选择或拖拽上传图片，限制每个5M以内
										  </el-upload>
										  
										  <div class="pic" v-if="domain.img_list" v-for="(tem,dex) in domain.img_list">
										  	<div class="image_box">
												<el-image 
												    class="image"
												    :src="tem.img_url_compressed" 
												    :preview-src-list="[tem.img_url_compressed]">
												  </el-image>
										  	</div>
										  	<div class="info">
										  		<div class="title">{{tem.title}}</div>
										  		<div class="exts" @click="delImgClick2(index,tem)">
										  			<div class="media_size">{{tem.media_size}}</div>
													<i class="el-icon-delete delicon"></i>
										  		</div>
										  	</div>
										  </div>
									
						
										</div>
									</el-form-item>
									
									<!-- 文件采集 -->
									<el-form-item :label="detailData.form_file_label" :prop="'domains.' + index + '.file'" v-if="detailData.has_file == 1">
										
										<div v-if="detailData.form_file_text" v-html="detailData.form_file_text"  style="line-height: 1.4;color: #999; margin-top: 10px; margin-bottom: -5px;"></div>
										<div class="pic2_box">
											<el-upload
												v-if="!domain.file_list || (domain.file_list && domain.file_list.length < detailData.form_file_limit)"
												:file-list="domain.file_list"
												accept=".txt,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.rar,.zip"
												action="#"
												drag
												multiple
												:auto-upload="false"
												:show-file-list="false"
												:limit="detailData.form_file_limit"
												:on-exceed="(files, fileList) => handleFileExceed2(files, fileList,index)"
												:on-change="(file, fileList) => handleFileChange2(file, fileList, index)"
											>
												<i class="el-icon-plus" style="margin-right: 8px;"></i>
												请选择或拖拽上传附件，限制每个5M以内
										  </el-upload>
										  
										  <div class="pic" v-if="domain.file_list" v-for="(tem,dex) in domain.file_list">
										  	<div class="image_box">
												  <img v-if="tem.media_ext == '.txt'" class="image file" src="https://images.cmptt.com/h5/media/cmptt/icon/icon_txt.png" />
												  <img v-if="tem.media_ext == '.pdf'" class="image file" src="https://images.cmptt.com/h5/media/cmptt/icon/icon_pdf.png" />
												  <img v-if="tem.media_ext == '.doc'" class="image file" src="https://images.cmptt.com/h5/media/cmptt/icon/icon_doc.png" />
										  		  <img v-if="tem.media_ext == '.docx'" class="image file" src="https://images.cmptt.com/h5/media/cmptt/icon/icon_docx.png" />
										  		  <img v-if="tem.media_ext == '.xls'" class="image file" src="https://images.cmptt.com/h5/media/cmptt/icon/icon_xls.png" />
										  		  <img v-if="tem.media_ext == '.xlsx'" class="image file" src="https://images.cmptt.com/h5/media/cmptt/icon/icon_xlsx.png" />
										  		  <img v-if="tem.media_ext == '.ppt'" class="image file" src="https://images.cmptt.com/h5/media/cmptt/icon/icon_ppt.png" />
										  		  <img v-if="tem.media_ext == '.pptx'" class="image file" src="https://images.cmptt.com/h5/media/cmptt/icon/icon_pptx.png" />
										  		  <img v-if="tem.media_ext == '.rar'" class="image file" src="https://images.cmptt.com/h5/media/cmptt/icon/icon_rar.png" />
												  <img v-if="tem.media_ext == '.zip'" class="image file" src="https://images.cmptt.com/h5/media/cmptt/icon/icon_zip.png" />
										  	</div>
										  	<div class="info">
										  		<div class="title">{{tem.title}}</div>
										  		<div class="exts" @click="delFileClick2(index,tem)">
										  			<div class="media_size">{{tem.media_size}}</div>
													<i class="el-icon-delete delicon"></i>
										  		</div>
										  	</div>
										  </div>
									
															
										</div>
									</el-form-item>
								
								</div>


							
							</div>
							
							<div style="width: 100%; margin-top: 30px; line-height: 1.5; font-size: 15px; color: #515a6e; padding-left: 160px; box-sizing: border-box; text-align: justify;" v-if="inviter">
								<i class="el-icon-warning-outline" style="margin-right: 5px;"></i>
								您是中国机械行业教育教学名师/先进工作者，本次培训免费，更可额外新增{{ this.inviter.gift_buy_count -1 }}名教师（可是本校或本领域一线教师、骨干教师等）参加本次培训，{{ this.inviter.gift_buy_count -1 }}位老师的培训费免费
							</div>

							<div style="margin-top: 30px;" v-if="is_gift_add">
								<el-form-item>
									<!-- <el-button type="primary" @click="submitForm('dynamicValidateForm')">验证填写信息</el-button> -->
									<el-button @click="addDomain">新增报名人员</el-button>
									<!-- <el-button @click="resetForm('dynamicValidateForm')">重置报名人员信息</el-button> -->
								</el-form-item>
								<el-alert title="报名信息填写验证通过" type="success" v-if="alert_show1">
								</el-alert>
							</div>
							<div style=" width: 100%; margin-top: 30px; font-size: 15px; color: #515a6e; padding-left: 160px; box-sizing: border-box;"
								v-if="!is_gift_add && !inviter">
								<i class="el-icon-warning-outline" style="margin-right: 5px;"></i>如需添加更多报名人员请联系工作人员
							</div>

						</el-form>

						<div v-if="detailData && (detailData.student_price || (detailData.package_items && detailData.package_items.length>0 && detailData.package_items[0].student_price))"
							style="display: flex; flex-direction: column; width: 640px;font-size: 14px; margin-top: 12px; line-height: 1.5;text-align: justify;">
							暂不支持同时添加多种身份的报名人员，如有需要请分别使用不同账号提交报名信息或联系工作人员<br>
							温馨提示：学生身份的报名人员，参会时请务必携带学生证，会务组会在报到时核验报名信息
						</div>
					</div>


					<div v-if="total_fee > 0" style="display: flex; margin-top: 58px;">
						<el-checkbox v-model="checked" @change="checkedChangeEvent">我要发票<span style=" font-size: 14px;">（如果您不需要发票请取消勾选）</span></el-checkbox>
					</div>



					<div v-if="checked">

						<div style="font-size: 18px;color: #333;font-weight: 600; padding: 40px 0 10px 0;">
							发票信息
						</div>

						<div style="display: flex; flex-direction: column; width: 640px;">
							<div style="font-size: 14px; margin: 12px 0 30px 0; line-height: 1.5; text-align: justify;">
								我社统一开具电子普票，会后发送至您预留的邮箱。如需专票，请联系工作人员。<br>
								为避免后续开具的发票无法用于报销，填写发票信息前务必找贵校/贵司财务专员确认最新开票信息及可开发票类目。
							</div>


							<el-form :model="dynamicValidateForm2" ref="dynamicValidateForm2" label-width="260px">
								<div v-for="(domain, index) in dynamicValidateForm2.domains" :key="domain.key">
									
									
									<el-form-item label="开票金额">
										<div style="display:flex;  width: 100%; line-height: 1; align-items: center; ">
											<div style="display: flex; flex-direction: column;justify-content: center;  align-items: center;font-size: 18px;font-weight: 600;">
												{{domain.total_fee}}
												<span style="font-size: 12px;margin-top: 5px;">（每张开票金额）</span>
											</div>
											
											<div style="display: flex; justify-content: center;  align-items: center;font-size: 18px;font-weight: 600;">
												×
											</div>
											
											<div style="display: flex; flex-direction: column; justify-content: center;  align-items: center;font-size: 18px;font-weight: 600;">
												{{domain.invoice_count}}
												<span style="font-size: 12px;margin-top: 5px;">（开票张数）</span>
											</div>
											
											<div style="display: flex; justify-content: center;  align-items: center;font-size: 18px;font-weight: 600;">
												=
											</div>
											
											<div style="display: flex;flex-direction: column; justify-content: center;  align-items: center;font-size: 18px;font-weight: 600;">
												{{total_fee}}
												<span style="font-size: 12px; margin-top: 5px;">（开票总金额）</span>
											</div>
										</div>
										
									</el-form-item>
									
									<el-form-item v-if="gift_count>1" :prop="'domains.' + index + '.invoice_make_type'"
										label="开具方式"
										:rules="[{ required: true, message: '请选择发票类目', trigger: 'change' }]">
										<el-radio-group v-model="domain.invoice_make_type" @input="bindInvoiceData">
											<el-radio label="统一开具"></el-radio>
											<el-radio label="单独开具"></el-radio>
										</el-radio-group>
									</el-form-item>
									
									
									<el-form-item :prop="'domains.' + index + '.invoice_type'" label="发票类型"
										:rules="[{ required: true, message: '请选择发票类型', trigger: 'change' }]">
										<el-radio-group v-model="domain.invoice_type" @input="changeInvoiceType($event,index)">
											<el-radio label="2">数电普票</el-radio>
											<el-radio label="1">数电专票</el-radio>
										</el-radio-group>
									</el-form-item>
									
									<el-form-item v-if="gift_count>1 && domain.invoice_make_type == '统一开具'" :prop="'domains.' + index + '.invoice_unit'" label="计量单位"
										:rules="[{ required: true, message: '请选择计量单位', trigger: 'change' }]">
										<el-radio-group v-model="domain.invoice_unit">
											<el-radio label="人">人（单位 人，数量 {{gift_count}}）</el-radio>
											<el-radio label="次">次（单位 次，数量 1）</el-radio>
										</el-radio-group>
									</el-form-item>
									
									
									<el-form-item :prop="'domains.' + index + '.title'" label="发票抬头"
										:rules="[{ required: true, message: '请输入发票抬头', trigger: ['blur', 'change'] }]">
										<!-- <el-input v-model="domain.title" placeholder="请输入发票抬头"></el-input> -->
										<el-autocomplete
										      class="inline-input"
										      v-model="domain.title"
										      :fetch-suggestions="querySearch"
										      placeholder="请输入发票抬头"
											  :trigger-on-focus="false"
										      @select="handleSelect"
											  style="width: 380px;"
										    ></el-autocomplete>
									</el-form-item>
									<el-form-item :prop="'domains.' + index + '.tax_id'" label="发票税号"
										:rules="[{ required: true, message: '请输入发票税号', trigger: ['blur', 'change'] },{ min: 15, max: 20, message: '请输入正确的发票税号', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.tax_id" placeholder="请输入发票税号(三证合一后税号为18位)"></el-input>
									</el-form-item>
									
									<el-collapse v-model="domain.active_names" accordion>
										<el-collapse-item name="1">
											<template slot="title">
												地址/电话/开户行/账号(普票非必填，点击可展开填写) <i class="header-icon el-icon-info"></i>
											</template>
									
											<div>
												<el-form-item :prop="'domains.' + index + '.registered_address'"
													label="地址" :rules="domain.rules_registered_address">
													<el-input v-model="domain.registered_address"
														placeholder="请输入开票信息中的单位地址"></el-input>
												</el-form-item>
												<el-form-item :prop="'domains.' + index + '.registered_contact'"
													label="电话" :rules="domain.rules_registered_contact">
													<el-input v-model="domain.registered_contact"
														placeholder="请输入开票信息中的单位电话"></el-input>
												</el-form-item>
												<el-form-item :prop="'domains.' + index + '.bank'" label="开户行" :rules="domain.rules_bank">
													<el-input v-model="domain.bank"
														placeholder="请输入开票信息中的开户行名称"></el-input>
												</el-form-item>
												<el-form-item :prop="'domains.' + index + '.bank_account'"
													label="账号" :rules="domain.rules_bank_account">
													<el-input v-model="domain.bank_account"
														placeholder="请输入开票信息中的银行账号"></el-input>
												</el-form-item>
											</div>
										</el-collapse-item>
									</el-collapse>


									<el-form-item :prop="'domains.' + index + '.category'" label="发票类目"
										:rules="[{ required: true, message: '请选择发票类目', trigger: 'change' }]">
										<div style="line-height: 1.4;margin: 12px 0;color: #999"
											v-if="detailData.case_type != 2">
											开具的发票中<span v-if="detailData.invoice_category_items.includes('会务费')">会务费显示为『*生产生活服务*会务费』，</span><span v-if="detailData.invoice_category_items.includes('会议费')">会议费显示为『*生产生活服务*会议费』，</span><span v-if="detailData.invoice_category_items.includes('培训费')">培训费显示为『*生产生活服务*{{detailData.title}}培训费』，</span>请根据可开类目选择。为防止类目额度超标或当月类目额度已使用完无法报销等情况，请老师最好咨询贵校/贵司财务专员后再进行选择。
										</div>
										<el-radio-group v-model="domain.category">
											<el-radio :label="invoice_category_item" v-for="invoice_category_item in detailData.invoice_category_items"></el-radio>
										</el-radio-group>
									</el-form-item>


									<!-- <el-form-item v-if="domain.category == '其他'"
										:prop="'domains.' + index + '.category_other'" label="其他发票类目"
										:rules="[{ required: true, message: '请输入发票类目', trigger: 'change' }]">
										<el-input v-model="domain.category_other" placeholder="请输入其他发票类目"></el-input>
									</el-form-item> -->
									
									<el-form-item :prop="'domains.' + index + '.remark'" label="发票备注(非必填)">
										<div style="color: #999; font-size: 14px;">备注内容将显示在发票备注栏中</div>
										<el-input v-model="domain.remark" placeholder="请输入发票备注"></el-input>
									</el-form-item>
									
									<el-form-item :prop="'domains.' + index + '.email'" label="发票接收邮箱"
										:rules="[{ required: true, message: '请输入邮箱地址', trigger: ['blur', 'change'] },{ type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.email" placeholder="请输入邮箱地址"></el-input>
									</el-form-item>
									<el-form-item :prop="'domains.' + index + '.mobile'" label="发票接收人手机"
										:rules="[{ required: true, message: '请输入手机号码', trigger: ['blur', 'change'] },{ pattern: /^[1][3-9][0-9]{9}$/, message: '请输入正确的手机号码', trigger: ['blur', 'change'] }]">
										<el-input v-model="domain.mobile" placeholder="请输入手机号码"></el-input>
									</el-form-item>


									<div style="margin-top: 30px;">
										<el-alert title="开票信息填写验证通过" type="success" v-if="alert_show2">
										</el-alert>
									</div>

								</div>
							</el-form>
						</div>
					</div>
				</div>

				<div @click="infoConfirm"
					style="display: flex; justify-content: center; align-items: center; margin-top: 40px;">
					<div
						style="font-size: 17px; background: linear-gradient(to right,#C63E31,#FB9026); color: #fff;  border-radius: 34px; width:150px ; height:34px; display: flex; justify-content: center; align-items: center; cursor: pointer;">
						提交报名信息</div>
				</div>

			</div>
		</div>
		
		
	
		
		<div class="sign_up_container" style="width: 1200px; display: flex; flex-direction: column;" v-if="page_index == 2">
			<div style="display: inline-flex; flex-direction: column; width: 1200px;  z-index: 3;">
				<div style="display: flex; margin: 70px 0 40px 0;">
					<div style="margin-right: 10px;width: 5px;background: linear-gradient(to bottom,#ff9000,#c93a2e);"></div>
					<div v-if="stateData.result == 1"
						style="display: flex;flex-direction: column; line-height: 1;font-size: 28px; color: #333;">
						报名成功
					</div>
					<div v-if="stateData.result == 0"
						style="display: flex;flex-direction: column; line-height: 1;font-size: 28px; color: #333;">
						提交成功
					</div>
				</div>
			</div>
		
			<div style="display: flex;flex-direction: column; background-color: #fff; box-shadow: 1px 2px 1px #eee; border-radius: 15px; padding: 50px; margin-bottom: 50px; ;line-height: 1;">
		
				<div style="display: flex;flex-direction: column;justify-content: center; align-items: center; padding: 48px 0 40px 0; box-sizing: border-box; border-bottom: 1px solid #eee;">
					<img src="../../assets/images/icon_success.png" style="width: 120px; height: auto;" />
					<div v-if="stateData.result == 0" style=" font-size: 24px; margin-top: 30px; color: #333;">
						报名信息已提交成功
					</div>
					<div v-if="stateData.result == 1" style=" font-size: 24px; margin-top: 30px; color: #333;">
						报名成功
					</div>
					<div style="width: 640px;display: flex; flex-direction:column;margin-top: 40px; font-size: 17px; line-height: 1.75;color: #333;">
						<div>报名信息如下：</div>
						<div>会议名称：{{detailData.title}}</div>
						<div v-if="id=='t_d5757705cd5f4484ace4fb653d62b34f'">会议日期：满30人开班</div>
						<div v-if="id!='t_d5757705cd5f4484ace4fb653d62b34f'">会议日期：{{detailData.start_at}} 至 {{detailData.stop_at}}</div>
						<div>会议地点：{{stateData.place}}</div>
						<div>参会人数：{{stateData.applyer_count}} 人</div>
						<div>人员名单：{{stateData.applyer}}</div>
						<div v-if="orderData.total_fee == 0">
							<div v-if="orderData.discount_fee == 0">报名费用：免费</div>
							<div v-if="orderData.discount_fee > 0">
								<div>报名费用：{{orderData.original_total_fee}} 元</div>
								<div>实际应缴：{{orderData.total_fee}} 元</div>
								<div>优惠金额：{{orderData.discount_fee}} 元</div>
							</div>
						</div>
						<div v-if="orderData.total_fee > 0">
							<div style="display: flex; justify-content: space-between;" v-if="orderData.discount_fee == 0">
								<div>报名费用：{{orderData.total_fee}} 元</div>
								<div v-if="detailData.is_open_coupon == 1"  style="display: inline-flex; color:#ca3f1e; border-bottom: 1px solid #ca3f1e; cursor: pointer;" @click="couponClick">使用优惠码</div>
							</div>
							<div  v-if="orderData.discount_fee > 0">
								<div>报名费用：{{orderData.original_total_fee}} 元</div>
								<div>实际应缴：{{orderData.total_fee}} 元</div>
								<div>优惠金额：{{orderData.discount_fee}} 元</div>
							</div>
							<div v-if="stateData.result == 1">缴费状态：已缴费</div>
							<div v-if="stateData.result == 0">缴费状态：未缴费</div>
							<div style="display: flex; justify-content: space-between;" v-if="detailData.is_open_pay == 1 && stateData.pay_method == 0">
								<div>缴费方式确认：未确认</div>
								<div style="display: inline-flex; color:#ca3f1e; border-bottom: 1px solid #ca3f1e; cursor: pointer;" @click="toPay">确认缴费方式</div>
							</div>
							<div style="display: flex; flex-direction: column;" v-if="stateData.pay_method !=0">
								<div style="display: flex; justify-content: space-between;" v-if="stateData.result == 0">
									<div style="display: inline-flex;" v-if="stateData.pay_method == 1">缴费方式确认：在线支付</div>
									<div style="display: inline-flex;" v-if="stateData.pay_method == 2">缴费方式确认：对公转账</div>
									<div style="display: inline-flex;" v-if="stateData.pay_method == 3">缴费方式确认：现场缴费</div>
									<div style="display: inline-flex;" v-if="stateData.pay_method == 4">缴费方式确认：扫码支付</div>
									<div style="display: inline-flex; color:#ca3f1e; border-bottom: 1px solid #ca3f1e; cursor: pointer;" @click="toPay">更换缴费方式</div>
								</div>
								<div style="display: flex; flex-direction: column;" v-if="stateData.result == 1">
									<div style="display: inline-flex;" v-if="stateData.pay_method == 1">缴费方式：在线支付</div>
									<div style="display: inline-flex;" v-if="stateData.pay_method == 2">缴费方式：对公转账</div>
									<div style="display: inline-flex;" v-if="stateData.pay_method == 3">缴费方式：现场缴费</div>
									<div style="display: inline-flex;" v-if="stateData.pay_method == 4">缴费方式：扫码支付</div>
								</div>
							</div>
							
							<div v-if="stateData.result == 0" style="display: flex; flex-direction: column;color: #a0a0a0;margin-top: 24px; line-height: 1.5; text-align: justify;">
								<div v-if="stateData.pay_method == 2">您选择的支付方式为对公转账，支持公对公转账，也支持个人对公转账</div>
								<div v-if="stateData.pay_method == 3">您选择的支付方式为现场缴费，会议报到当天现场缴费，现场缴费支持刷卡、支付宝、微信支付，现场缴费均按原价缴费</div>
								<div v-if="detailData.is_open_pay == 0">本次会议采用预报名形式，{{detailData.is_open_pay_message}}，后续缴费功能会自动开放，缴费方式支持微信在线支付、对公转账、现场缴费。</div>
							</div>
							
							<div v-if="detailData.is_show_joiner == 1">
								<div>
									您已加入团购，报名满<span style="font-weight: 600; padding: 0 5px;">50</span>人，系统自动改价，当前已报名 <span style="font-weight: 600;padding: 0 5px;">{{detailData.joiner_count}}</span>人
								</div>
							</div>
							
							<div v-if="id == 't_65e37a63f97346e7be8f42f38431c926' && stateData.result == 0" style="margin-top: 24px;">
								立即缴费后，您可以按系统提示，<span @click="noteClick" style="border-bottom: 1px solid #444; padding-bottom: 2px;cursor: pointer;">上传符合投稿要求的学术论文（中文），有机会参与论文点评活动及核心期刊推荐。</span>
							</div>
							
							<div v-if="id == 't_2e1aebef039e430b897a014034b42fd6' && stateData.result == 0" style="margin-top: 24px;">
								立即缴费后，您可以按系统提示，上传符合投稿要求的学术论文（中文），有机会参与论文点评活动及核心期刊推荐。
							</div>
							
						</div>
					</div>
					
					<div v-if="detailData.is_open_pay == 1 && ((stateData.result == 1 && (id=='t_65e37a63f97346e7be8f42f38431c926' || id=='t_2e1aebef039e430b897a014034b42fd6')) || (detailData.is_reg == 1 && id=='t_eeb95d53e54b4deaa160ce6fb04e09b3'))"  style="width: 640px; margin: 32px 0;display: flex;flex-direction: column; margin-top: 64upx; ">
						<div v-if="!orderData.file_list || (orderData.file_list && orderData.file_list.length==0)" style="display: flex;flex-direction: column;">
							<div style=" font-size: 17px; line-height: 1.75;color: #444; text-align: justify;" v-if="id=='t_65e37a63f97346e7be8f42f38431c926'">
								如您愿意参与论文点评及推荐活动，请点击下方按钮上传<span @click="noteClick" style="border-bottom: 1px solid #444; padding-bottom: 4upx; cursor: pointer;">符合投稿要求的学术论文（中文）</span>。
							</div>
							
							<div style=" font-size: 17px; line-height: 1.75;color: #444; text-align: justify;" v-if="id=='t_2e1aebef039e430b897a014034b42fd6'">
								如您愿意参与论文点评及推荐活动，请点击下方按钮上传符合投稿要求的学术论文（中文）。
							</div>
							
							<div style=" font-size: 17px; line-height: 1.75;color: #444; text-align: justify;" v-if="id=='t_eeb95d53e54b4deaa160ce6fb04e09b3'">
								如您愿意参与核刊特约投稿活动，请点击下方按钮上传<span @click="noteClick" style="border-bottom: 1px solid #444; padding-bottom: 4upx; cursor: pointer;">符合投稿要求的学术论文（中文）</span>。
							</div>
							
							<div class="pic2_box">
								<el-upload
										v-if="!fileList || (fileList && fileList.length < 1)"
										:file-list="fileList"
										accept=".pdf,.doc,.docx"
										action="#"
										drag
										multiple
										:auto-upload="false"
										:show-file-list="false"
										:limit="3"
										:on-exceed="handleFileExceed"
										:on-change="handleFileChange"
									>
										<i class="el-icon-plus" style="margin-right: 8px;"></i>
										请选择或拖拽上传图片，限制每个5M以内
								  </el-upload>
							  
								  <div class="pic" v-if="fileList" v-for="(item,index) in fileList">
									<div class="image_box">
										  <img v-if="getFileExt(item.name) == '.docx'" class="image file" src="https://images.cmptt.com/h5/media/cmptt/icon/icon_docx.png" />
										  <img v-if="getFileExt(item.name) == '.doc'" class="image file" src="https://images.cmptt.com/h5/media/cmptt/icon/icon_doc.png" />
										  <img v-if="getFileExt(item.name) == '.pdf'" class="image file" src="https://images.cmptt.com/h5/media/cmptt/icon/icon_pdf.png" />
										  <img v-if="getFileExt(item.name) == '.zip'" class="image file" src="https://images.cmptt.com/h5/media/cmptt/icon/icon_zip.png" />
										  <img v-if="getFileExt(item.name) == '.rar'" class="image file" src="https://images.cmptt.com/h5/media/cmptt/icon/icon_rar.png" />
									</div>
									<div class="info">
										<div class="title">{{item.name}}</div>
										<div class="exts" @click="delFileClick(item)">
											<div class="media_size">{{getFileSize(item.size)}}</div>
											<i class="el-icon-delete delicon"></i>
										</div>
									</div>
								  </div>
							</div>
							<div style=" width: 100%; display: flex;flex-direction: row; margin-top: 16px;">
								<div @click="uploadFileConfirmClick" style="font-size: 17px; background: linear-gradient(to right,#C63E31,#FB9026); color: #fff;  border-radius: 34px; width:240px; height:34px; display: flex; justify-content: center; align-items: center; cursor: pointer;">
									确认上传
								</div>
							</div>
						</div>
						
						<div v-if="orderData.file_list && orderData.file_list.length>0" style="display: flex;flex-direction: column; color: #333;font-size: 17px; line-height: 1.75; ">
							<div style="text-align: justify;">
								论文已上传，工作人员会尽快转给相关负责老师。
								<span v-if="id=='t_65e37a63f97346e7be8f42f38431c926'" @click="noteClick" style="border-bottom: 1px solid #333; padding-bottom: 4upx; cursor: pointer;">点击可了解论文点评与推荐活动更多内容。</span>
								<span v-if="id=='t_eeb95d53e54b4deaa160ce6fb04e09b3'" @click="noteClick" style="border-bottom: 1px solid #333; padding-bottom: 4upx; cursor: pointer;">点击了解核刊特约投稿活动更多内容。</span>
							</div>
							<div class="pic2_box">
								<div class="pic_box-title">已上传文件（论文）：</div>
								<div class="pic" v-for="(item,index) in orderData.file_list">
									<div class="image_box">
										  <img v-if="item.media_ext == '.docx'" class="image file" src="https://images.cmptt.com/h5/media/cmptt/icon/icon_docx.png" mode="aspectFill"/>
										  <img v-if="item.media_ext == '.doc'" class="image file" src="https://images.cmptt.com/h5/media/cmptt/icon/icon_doc.png" mode="aspectFill"/>
										  <img v-if="item.media_ext == '.pdf'" class="image file" src="https://images.cmptt.com/h5/media/cmptt/icon/icon_pdf.png" mode="aspectFill"/>
										  <img v-if="item.media_ext == '.zip'" class="image file" src="https://images.cmptt.com/h5/media/cmptt/icon/icon_zip.png" mode="aspectFill"/>
										  <img v-if="item.media_ext == '.rar'" class="image file" src="https://images.cmptt.com/h5/media/cmptt/icon/icon_rar.png" mode="aspectFill"/>
									</div>
									<div class="info">
										<div class="title">{{item.title}}</div>
										<div class="exts">
											<div class="media_size">{{item.media_size}}</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					
					
					
					<div v-if="detailData.is_open_pay == 1 && stateData.result == 0" style=" width: 640px; margin: 32px 0;">
						<div style=" width: 100%; display: flex;flex-direction: row; justify-content:  space-between;">
							<div @click="toPay" style="font-size: 17px; background: linear-gradient(to right,#C63E31,#FB9026); color: #fff;  border-radius: 34px; width:240px; height:34px; display: flex; justify-content: center; align-items: center; cursor: pointer;">
								<div v-if="stateData.pay_method !=2 && stateData.pay_method !=4">立即缴费</div>
								<div v-if="stateData.pay_method == 2">查看转账信息</div>
								<div v-if="stateData.pay_method == 4">查看扫码信息</div>
							</div>
							
							<div @click="toDetail" style="font-size: 17px; background: linear-gradient(to right,#C63E31,#FB9026); color: #fff;  border-radius: 34px; width:240px; height:34px; display: flex; justify-content: center; align-items: center; cursor: pointer;">
								稍后缴费
							</div>
						</div>
						<div v-if="!orderData.media_list || (orderData.media_list && orderData.media_list.length == 0)" style="width: 100%;display: flex;flex-direction: column; margin-top: 40px; ">
							<div style="font-size: 17px;color: #333;line-height: 1.75;">如果您已经通过对公转账或扫码支付的方式完成缴费，请上传缴费凭证，以便工作人员及时确认缴费状态。</div>
							<div class="pic2_box">
								<el-upload
										v-if="!imgList || (imgList && imgList.length < 1)"
										:file-list="imgList"
										accept=".jpg,.jpeg,.png,.bmp"
										action="#"
										drag
										multiple
										:auto-upload="false"
										:show-file-list="false"
										:limit="3"
										:on-exceed="handleImgExceed"
										:on-change="handleImgChange"
									>
										<i class="el-icon-plus" style="margin-right: 8px;"></i>
										请选择或拖拽上传图片，限制每个5M以内
								  </el-upload>
							  
								  <div class="pic" v-if="imgList" v-for="(item,index) in imgList">
									<div class="image_box">
										<el-image 
											class="image"
											:src="getImgUrl(item.raw)" 
											:preview-src-list="[getImgUrl(item.raw)]">
										  </el-image>
									</div>
									<div class="info">
										<div class="title">{{item.name}}</div>
										<div class="exts" @click="delImgClick(item)">
											<div class="media_size">{{getFileSize(item.size)}}</div>
											<i class="el-icon-delete delicon"></i>
										</div>
									</div>
								  </div>
							</div>
							<div style=" width: 100%; display: flex;flex-direction: row; margin-top: 16px;">
								<div @click="uploadImgConfirmClick" style="font-size: 17px; background: linear-gradient(to right,#C63E31,#FB9026); color: #fff;  border-radius: 34px; width:240px; height:34px; display: flex; justify-content: center; align-items: center; cursor: pointer;">
									确认上传
								</div>
							</div>
						</div>
					</div>
					
					<div v-if="orderData.media_list && orderData.media_list.length>0" style="width: 640px; display: flex; flex-direction:  column;">
						<div style="font-size: 17px;color: #333;line-height: 1.75;">
							<span v-if="stateData.result == 0">缴费凭证已上传，工作人员会尽快确认缴费状态。</span>
							<span v-if="stateData.result == 1">缴费凭证（截图）：</span>
						</div>
						<div class="pic2_box">
							  <div class="pic" v-for="(item,index) in orderData.media_list">
								<div class="image_box">
									<el-image 
										class="image"
										:src="item.img_url_compressed" 
										:preview-src-list="loadPreviewSrcList()">
									  </el-image>
								</div>
								<div class="info">
									<div class="title">{{item.title}}</div>
									<div class="exts">
										<div class="media_size">{{item.media_size}}</div>
									</div>
								</div>
							  </div>
						</div>
					</div>
					
					
					<div v-if="detailData.is_open_study == 1 && stateData.result == 1" style=" width: 640px; display: flex;flex-direction: column; margin-top: 60px;">
						<div @click="toStudyClick" style="font-size: 17px; background: linear-gradient(to right,#C63E31,#FB9026); color: #fff;  border-radius: 34px; width:100%; height:34px; display: flex; justify-content: center; align-items: center; cursor: pointer;">
							开启特训营的学习
						</div>
					</div>
					
					
					<div v-if="id!='t_d396f3411518405ab681cfadd66d3464'" style=" width: 640px; font-size: 17px;color: #999; line-height: 1.3; margin-top: 50px; display: flex; flex-direction: column; ;justify-content: center;align-items: center; ">
						<div>报名后，请各位老师扫描下方二维码添加客服微信号，添加好友时请备注：会议名称+姓名+学校+老师/学生/其他，邀请您进本次会议专属群，我们将在群内发布本次会议更多学习信息。</div>
						<div style="margin-top: 30px;" v-if="detailData">
							<img v-if="detailData.kf_qrcode_img_url" :src="detailData.kf_qrcode_img_url" style="width: 320px;" />
							<img v-if="!detailData.kf_qrcode_img_url" src="../../assets/images/qrcode_kf.jpg" style="width: 320px;" />
						</div>
					</div>
					
					<div v-if="id=='t_d396f3411518405ab681cfadd66d3464'" style=" width: 640px; font-size: 17px;color: #999; line-height: 1.3; margin-top: 50px; display: flex; flex-direction: column; ;justify-content: center;align-items: center; ">
						<div>报名后，请各位老师扫描下方二维码加入本次活动专属群，进群后请更改群昵称：姓名+学校，我们将在群内发布本次活动更多信息。</div>
						<div style="margin-top: 30px;" v-if="detailData">
							<img v-if="!orderData.group_qrcode_url" src="../../assets/images/qrcode_kf.jpg" style="width: 320px;" />
							<img v-if="orderData.group_qrcode_url" :src="orderData.group_qrcode_url" style="width: 320px;" />
						</div>
						<div style="margin-top: 30px;">扫描下方二维码即可添加本次活动专属客服微信，活动相关问题均可咨询。</div>
						<div style="margin-top: 30px;" v-if="detailData">
							<img v-if="detailData.kf_qrcode_img_url" :src="detailData.kf_qrcode_img_url" style="width: 320px;" />
							<img v-if="!detailData.kf_qrcode_img_url" src="../../assets/images/qrcode_kf.jpg" style="width: 320px;" />
						</div>
					</div>
					
					
				</div>
				<div style="display: flex; flex-direction: column; padding:40px 0; box-sizing: border-box;">
					<div style="display: flex;flex-direction: column;">
						<div style="font-size: 18px; color: #666;line-height: 1.4; margin-top: 40px;">
							推荐您关注我们的微信公众号，<br>
							获取教师系统能力特训营及数字教研室的最新活动信息，<br>
							结识更多优秀教师好友。
						</div>
						<div style="display: flex;  justify-content: space-between; margin-top: 40px;">
							<div style="display: flex;align-items: flex-end; ">
								<div style="width: 132px;height: 132px;border: 1px solid #eee; background-color: #eee; margin-right: 20px;">
									<img src="../../assets/images/qrcode_for_cmptt.jpg" style="width: 130px;" />
								</div>
								<div style="font-size: 18px;">
									<i class="el-icon-caret-left"></i>
									扫码关注公众号
								</div>
							</div>
							<div style="display: flex;align-items: flex-end;">
								<img src="../../assets/images/logo.png" style="width: 180px; height: auto;" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		

		<div class="sign_up_container" style="width: 1200px; display: flex; flex-direction: column;" v-if="page_index == 3">
			<!-- 支付 -->
			<div style="display: inline-flex; flex-direction: column; width: 1200px;  z-index: 3;">
				<div style="display: flex; margin: 70px 0 40px 0;">
					<div style="margin-right: 10px;width: 5px;background: linear-gradient(to bottom,#ff9000,#c93a2e);">
					</div>
					<div style="display: flex;flex-direction: column; line-height: 1;font-size: 28px; color: #333;">
						支付
					</div>
				</div>
			</div>

			<div style="display: flex;flex-direction: column; background-color: #fff; box-shadow: 1px 2px 1px #eee; border-radius: 15px; padding: 35px; margin-bottom: 60px;line-height: 1;">
				<div style="font-size: 18px;color: #333; font-weight: 600;">请选择支付方式</div>
				<div class="pay_tabs">
					
					<div v-if="detailData.is_online_pay == 1" class="pay_tab" :class="{'actived':pay_tab_index == 1}" @click="changePayTab(1)">
						<img src="../../assets/images/icon_weixin.png" style="width: 50px;margin-right: 10px;" />
						微信支付
						<div v-if="pay_tab_index == 1" class="tag">
							<i class="el-icon-check" style="color: #fff;font-size:14px;"></i>
						</div>
					</div>
					
					<div v-if="detailData.is_scan_pay == 1 && detailData.payment_qrcode_img_url" class="pay_tab" :class="{'actived':pay_tab_index == 4}" @click="changePayTab(4)">
						<img src="../../assets/images/icon_qr_scan.png" style="width: 50px; margin-right: 10px;" />
						扫码支付
						<div v-if="pay_tab_index == 4" class="tag">
							<i class="el-icon-check" style="color: #fff;font-size:14px;"></i>
						</div>
					</div>
					
					<div class="pay_tab" :class="{'actived':pay_tab_index == 2}" @click="changePayTab(2)">
						<img src="../../assets/images/icon_transfer.png" style="width: 50px; margin-right: 10px;" />
						对公转账
						<div v-if="pay_tab_index == 2" class="tag">
							<i class="el-icon-check" style="color: #fff;font-size:14px;"></i>
						</div>
					</div>
					
					<div v-if="stateData.is_offline_pay == 1" class="pay_tab" :class="{'actived':pay_tab_index == 3}" @click="changePayTab(3)">
						<img src="../../assets/images/icon_face_to_face.png" style="width: 50px; margin-right: 10px;" />
						现场缴费
						<div v-if="pay_tab_index == 3" class="tag">
							<i class="el-icon-check" style="color: #fff;font-size:14px;"></i>
						</div>
					</div>
				</div>


				<div v-if="pay_tab_index == 1" style="display: flex; flex-direction: column; justify-content: center; align-items: center; margin-top: 65px;">
					<div style="border: 1px solid #eee; background-color: #eee; width: 232px; height: 232px;">
						<div ref="qrcode" style="width: 230px; height: 230px;"></div>
					</div>
					<div style="font-size: 24px; margin-top: 40px;" v-if="orderData && orderData.total_fee">
						总金额：¥{{orderData.total_fee}}
					</div>
					<div style="font-size: 22px;color: #999; margin-top:15px;">
						请使用微信扫码支付
					</div>
				</div>
				
				<div v-if="pay_tab_index == 4" style="display: flex; flex-direction: column; justify-content: center; align-items: center; margin-top: 65px;">
					<div style="border: 1px solid #eee; background-color: #eee; width: 300px;  display: inline-flex;">
						<img :src="detailData.payment_qrcode_img_url" style="width: 300px; height: auto;"/>
					</div>
					<div style="font-size: 24px; margin-top: 40px;text-align: center;" v-if="orderData && orderData.total_fee">
						总金额：¥{{orderData.total_fee}}
					</div>
					<div style="font-size: 22px;color: #999; margin-top:15px;">
						请使用微信或支付宝扫码支付
					</div>
					<div style="font-size: 20px; line-height: 1.5; text-align: justify;" v-if="id == 't_819eb6f47ed245f095779e5b4d039316'"><br>
						培训缴费方式：900元/人，4人团体报名合计3000元<br>
						1、公务卡绑定微信或者支付宝，点击缴费链接：<a href='https://meeting.sae-china.org/AVETT202502/'>https://meeting.sae-china.org/AVETT202502/</a><br>
						2. 点击“个人报名”/“团体报名”（未曾在学会网站上注册过的老师请先注册，忘记密码的请找回密码或者更换邮箱重新注册，有问题可以与我联系）<br>
						3. 确认参会信息：点击“确认信息并报名” <br>
						4. 确认订单信息：选择“线上缴费”，点击“下一步” <br>
						5. 扫码支付，动态二维码十分钟内有效，可以其他人代付<br>
						6. 发票信息：自行填写（默认开电子普票）<br>
						7. 确认函：请截图本页，包含学员信息及已付金额，发给贾老师<br>
					</div>
				</div>
				
				
				<div v-if="pay_tab_index == 2" style="display: flex; flex-direction: column; justify-content: center; align-items: center; margin-top: 100px; line-height: 1;">
					<div style="font-size: 18px; line-height: 2;" v-if="orderData">
						<span style="font-weight: 600;" v-if="orderData.total_fee">打款金额：</span>¥ {{orderData.total_fee}}<br>
						<span style="font-weight: 600;">收款账号：</span>{{orderData.transfer_info.bank_account_number}}<br>
						<span style="font-weight: 600;">收款公司名称：</span>{{orderData.transfer_info.bank_account_name}}<br>
						<span style="font-weight: 600;">开户行：</span>{{orderData.transfer_info.bank_name}}<br>
						<span style="font-weight: 600;">备注信息：</span><span v-if="orderData.transfer_info.transfer_text">{{orderData.transfer_info.transfer_text}}</span><span v-if="!orderData.transfer_info.transfer_text && orderData.remark">{{orderData.remark}}</span><br>
						<span style="color: #999;">温馨提示：对公转账支持公对公转账，也支持个人对公转账</span>
					</div>
					<div @click="copyText" style="width: 160px; height: 36px; border-radius: 10px;  background-color: #FCA459;color: #fff; font-size: 18px; display: flex;justify-content: center; align-items: center; margin-top: 35px; margin-bottom: 40px; cursor: pointer;">
						一键复制转账信息
					</div>
				</div>
				<div v-if="pay_tab_index == 3" style="display: flex; flex-direction: column; justify-content: center; align-items: center; margin-top: 100px; line-height: 1;">
					<div style="font-size: 24px; line-height: 2; width: 500px;">
						温馨提示：<br>如果您选择参加线下课程时现场缴费，需要按原始定价<span v-if="detailData.is_early_bird">{{detailData.line_price}}元</span>缴费，缴费成功后由工作人员手动更新订单状态，订单状态更新后即可解锁线上课程或线上直播回放，请各位老师根据需要选择支付方式。
					</div>
				</div>
				<div v-if="pay_tab_index == 1" @click="finishConfirm" style="display: flex; justify-content: center; align-items: center; margin-top: 40px;">
					<div style="font-size: 17px; background: linear-gradient(to right,#C63E31,#FB9026); color: #fff;  border-radius: 34px; width:150px ; height:34px; display: flex; justify-content: center; align-items: center; cursor: pointer;">已完成支付</div>
				</div>
				<div v-if="pay_tab_index != 1" @click="updateOrderInfo()" style="display: flex; justify-content: center; align-items: center; margin-top: 40px;">
					<div style="font-size: 17px; background: linear-gradient(to right,#C63E31,#FB9026); color: #fff;  border-radius: 34px; width:150px ; height:34px; display: flex; justify-content: center; align-items: center; cursor: pointer;">确认支付方式</div>
				</div>
				
				<div v-if="id!='t_d396f3411518405ab681cfadd66d3464'" style=" font-size: 22px; margin-top: 50px;color: #999; display: flex; flex-direction: column; ;justify-content: center;align-items: center; line-height: 1.3; ">
					<div>报名后，请各位老师扫描下方二维码添加客服微信号，添加好友时请备注：会议名称+姓名+学校+老师/学生/其他，邀请您进本次会议专属群，我们将在群内发布本次会议更多学习信息。</div>
					<div style="margin-top: 30px;" v-if="detailData">
						<img v-if="detailData.kf_qrcode_img_url" :src="detailData.kf_qrcode_img_url" style="width: 320px;" />
						<img v-if="!detailData.kf_qrcode_img_url" src="../../assets/images/qrcode_kf.jpg" style="width: 320px;" />
					</div>
				</div>
				
				<div v-if="id=='t_d396f3411518405ab681cfadd66d3464'" style=" font-size: 22px; margin-top: 50px;color: #999; display: flex; flex-direction: column; ;justify-content: center;align-items: center; line-height: 1.3; ">
					<div>报名后，请各位老师扫描下方二维码加入本次活动专属群，进群后请更改群昵称：姓名+学校，我们将在群内发布本次活动更多信息。</div>
					<div style="margin-top: 30px;" v-if="detailData">
						<img v-if="!orderData.group_qrcode_url" src="../../assets/images/qrcode_kf.jpg" style="width: 320px;" />
						<img v-if="orderData.group_qrcode_url" :src="orderData.group_qrcode_url" style="width: 320px;" />
					</div>
					<div style="margin-top: 30px;">扫描下方二维码即可添加本次活动专属客服微信，活动相关问题均可咨询。</div>
					<div style="margin-top: 30px;" v-if="detailData">
						<img v-if="detailData.kf_qrcode_img_url" :src="detailData.kf_qrcode_img_url" style="width: 320px;" />
						<img v-if="!detailData.kf_qrcode_img_url" src="../../assets/images/qrcode_kf.jpg" style="width: 320px;" />
					</div>
				</div>
			</div>
		</div>


	
	</div>
</template>

<script>
	import QRCode from "qrcodejs2";
	import apiUrl from "../../js/apiUrl.js";
	import comm from "../../js/comm.js";
	import download from 'downloadjs';
	
	let pca = require("../../js/pca-code.json");

	export default {
		data() {
			return {
				dynamicValidateForm: {
					domains: [{
						package_items: '',
						package_items_title: '',
						package_items_disabled: false,
						is_show_more: true,
						name: '',
						mobile: '',
						sex: '',
						job_type: '',
						job_type_disabled: false,
						school_pca: '',
						school_province: '',
						school_city: '',
						school_area: '',
						school: '',
						college: '',
						title: '',
						title_other: '',
						duty: '',
						duty_other: '',
						teaching_length: '',
						subject: '',
						company: '',
						education: '',
						diet_type: '',
						check_in_date: '',
						check_in_date_other: '',
						check_in_plate_number: '',
						stay_type: '',
						hotel: '',
						room_type_before: '',
						room_type: '',
						room_type_other: '',
						room_share_with: '',
						stay_days_arr: '',
						stay_days: '',
						stay_days_other: '',
						is_visit: '',
						visit_plate_number: '',
						is_join: '',
						is_will: '',
						id_card: '',
						is_cert: '',
						is_cert_disabled: false,
						pca: '',
						province: '',
						city: '',
						area: '',
						address: '',
						email: '',
						course: '',
						major: '',
						department: '',
						hotel_check_in: '',
						hotel_check_out: '',
						is_member: '',
						wechat_id: '',
						is_report: '',
						report_title: '',
						is_speak: '',
						speak_title: '',
						interested: '',
						interested_arr: '',
						dine_items: '',
						dine_items_arr: [],
						img_list: [],
						file_list: [],
						key: Date.now()
					}]
				},
				dynamicValidateForm2: {
					domains: [{
						invoice_make_type: '统一开具',
						invoice_unit: '人',
						invoice_count: '',
						title: '',
						tax_id: '',
						invoice_type: '2',
						category: '',
						category_other: '',
						active_names: '',
						bank: '',
						bank_account: '',
						registered_address: '',
						registered_contact: '',
						rules_bank: {},
						rules_bank_account: {},
						rules_registered_address: {},
						rules_registered_contact: {},
						email: '',
						mobile: '',
						gift_buy_count: '',
						price: '',
						total_fee: '',
						remark: '',
						key: Date.now()
					}]
				},
				checked: true, //是否开具发票
				page_index: 0,
				pay_tab_index: 1,
				id: null,
				path: null,
				detailData: null,
				gift_count: 1,
				is_gift_add: false,
				total_fee: 0,
				price: 0,
				alert_show1: false,
				alert_show2: false,
				search: {
					id: null,
					case_type: 2,
					gift_buy_count: 1,
					product_type: 27,
					is_invoice: 1,
				},
				/*
				orderData: {
					total_fee:'1280',
					out_trade_no:'17110695997V5M5W',
					remark:'',
					qrcode_url:'',
				},*/
				orderData: null,
				stateData: null,
				qrcode: null,
				isLogin: true,
				backtop_id: Date.now().toString(10),
				options: pca,
				invoice_title_list: null,
				showAlert: false,
				imgList : [],
				showAlert2: false,
				fileList : [],
				dutyList: [
					{
						label: '二级学院（系）领导'
					},
					{
						label: '教研室主任/教研组长'
					},
					{
						label: '专业带头人/负责人'
					},
					{
						label: '专任教师'
					},
					{
						label: '行政部门/岗位人员'
					},
					{
						label: '实训/实验岗位人员'
					},
					{
						label: '辅导员'
					},
					{
						label: '其他'
					},
				],
				titleList: [
					{
						label: '初级（助教/助理讲师/助理工程师）'
					},
					{
						label: '中级（讲师/一级教师/工程师）'
					},
					{
						label: '副高级（副教授/高级教师/高级工程师）'
					},
					{
						label: '正高级（教授/研究员/正高级教师/正高级工程师）'
					},
					{
						label: '行政部门/岗位人员'
					},
					{
						label: '高级技师'
					},
					{
						label: '辅导员'
					},
					{
						label: '其他'
					},
				],
				majorList: [
					{
						label: '智能网联汽车类'
					},
					{
						label: '新能源汽车类'
					},
					{
						label: '汽车制造类'
					},
					{
						label: '汽车维修类'
					},
					{
						label: '汽车营销服务类'
					},
					{
						label: '汽车其他'
					},
					{
						label: '非汽车'
					},
				],
				defaultReportDate:'',
				defaultStartDate2:'',
				defaultRangeDate:'',
				defaultStartDate:'',
				defaultEndDate:'',
				minDate:'',
				pickerOptions: {
				  disabledDate(time) {
					return time.getTime() < Date.now();
				  }
				},
				inviter: null,
				hotel_image_list:[
					'https://images.cmptt.com/h5/cmptt/hotel/20260710/b/1.jpg',
					'https://images.cmptt.com/h5/cmptt/hotel/20260710/b/2.jpg',
					'https://images.cmptt.com/h5/cmptt/hotel/20260710/b/3.jpg'
				]
			};
		},
		created() {
			document.title = "机工教师特训营";
			this.isLogin = localStorage.getItem("userLogInInfo") ? true : false;
			if (!this.isLogin) {
				//window.top.location.href = "/login";
				this.$router.push({ path: '/login' });
				return;
			}
			var option = {
				id: this.$route.query.id || "",
				path: this.$route.query.path || "",
				coupon_code: this.$route.query.coupon_code || "",
			};
			if (option.id) {
				this.id = option.id;
				if (option.path) {
					this.path = option.path;
				}
				if(option.coupon_code){
					this.search.coupon_code =option.coupon_code; 
				}
				this.search.id = this.id;
				this.getDetail();
				this.getInvoiceTitleList();
			}
		},
		components: {
			qrcode: QRCode,
		},
		methods: {
			dineCheckboxGroupChange(e,index){
				this.dynamicValidateForm.domains[index].dine_items = this.dynamicValidateForm.domains[index].dine_items_arr.join(";");
				console.log(JSON.stringify(JSON.stringify(this.dynamicValidateForm.domains)))
			},
			isVisitChangeEvent(e,index){
				if(e == '是（自行前往）'){
					var check_in_plate_number = this.dynamicValidateForm.domains[index].check_in_plate_number;
					if(check_in_plate_number){
						this.dynamicValidateForm.domains[index].visit_plate_number = check_in_plate_number;
					}
				}else{
					this.dynamicValidateForm.domains[index].visit_plate_number ='';
				}
			},
			stayTypeChange(e, index) {
				if (e == '自行安排') {
					this.dynamicValidateForm.domains[index].hotel = '';
					this.dynamicValidateForm.domains[index].room_type_before = '';
					this.dynamicValidateForm.domains[index].room_type = '';
					this.dynamicValidateForm.domains[index].room_type_other = '';
					this.dynamicValidateForm.domains[index].room_share_with = '';
					this.dynamicValidateForm.domains[index].stay_days = '';
				}
			},
			couponClick() {
				
				this.$prompt('使用优惠码，报名费会减免部分金额', '优惠码', {
				          confirmButtonText: '确定',
				          cancelButtonText: '取消',
				          inputPlaceholder: '请输入优惠码',
						  inputValidator:(value) =>{
							 if(!value.trim() || value.trim().length == 0){
								 return '优惠码不能为空';
							 }
						  },
				        }).then(({ value }) => {
				          
						  var that = this;
						  this.Ajax(apiUrl.tt_coupon_code_active, {
						  	coupon_code: value.trim(),
						  	out_trade_no: that.orderData.out_trade_no,
						  	product_id: that.orderData.product_id,
						  	product_type: that.orderData.product_type,
						  }, (data, code) => {
						  	that.orderData.total_fee = data.total_fee; 
						  	that.orderData.original_total_fee = data.original_total_fee;
						  	that.orderData.discount_fee = data.discount_fee;
						  	that.couponShow = false;
							
							if(that.orderData.total_fee == 0){
								that.checkOrderState();
							}
						  }, (data, code) => {
							this.$message({
							  type: 'info',
							  message: '优惠码不存在、失效或已被使用'
							}); 
							
						  });
						  
				        }).catch(() => {
				          this.$message({
				            type: 'info',
				            message: '取消输入'
				          });       
				        });
				
			},
			
			changeInvoiceType(e,index){
				this.$refs.dynamicValidateForm2.clearValidate();
				if(e == 1){
					this.dynamicValidateForm2.domains[index].active_names = '1';
					this.dynamicValidateForm2.domains[index].rules_bank = [{ required: true, message: '请输入开票信息中的开户行名称', trigger: ['blur', 'change'] }];
					this.dynamicValidateForm2.domains[index].rules_bank_account = [{ required: true, message: '请输入开票信息中的银行账号', trigger: ['blur', 'change'] }];;
					this.dynamicValidateForm2.domains[index].rules_registered_address = [{ required: true, message: '请输入开票信息中的单位地址', trigger: ['blur', 'change'] }];;
					this.dynamicValidateForm2.domains[index].rules_registered_contact = [{ required: true, message: '请输入开票信息中的单位电话', trigger: ['blur', 'change'] }];;
				}else{
					this.dynamicValidateForm2.domains[index].active_names = '';
					this.dynamicValidateForm2.domains[index].rules_bank = [];
					this.dynamicValidateForm2.domains[index].rules_bank_account = [];
					this.dynamicValidateForm2.domains[index].rules_registered_address = [];
					this.dynamicValidateForm2.domains[index].rules_registered_contact = [];
				}
			},
			noteClick(){
				if(this.id == 't_eeb95d53e54b4deaa160ce6fb04e09b3'){
					this.$alert('<img src="https://images.cmptt.com/h5/cmptt/detail/pc_20260507172399.jpg" style="width:100%"/>', '提示', {
					     customClass:'notebox',
						 dangerouslyUseHTMLString: true
					});
				}else if(this.id == 't_65e37a63f97346e7be8f42f38431c926'){
					this.$alert('<img src="https://images.cmptt.com/h5/cmptt/detail/pc_20250813184010.jpg" style="width:100%"/>', '提示', {
					     customClass:'notebox',
						 dangerouslyUseHTMLString: true
					});
				}
			},
			toDetail(){
				this.GoToDetail(this.detailData.product_type,this.detailData.id);
			},
			toPay(){
				this.page_index = 3;
				
				if(this.stateData.pay_method!=0){
					this.changePayTab(this.stateData.pay_method);
				}else{
					if(this.detailData.is_online_pay==1){
						this.changePayTab(1);
					}else if(this.detailData.is_scan_pay==1){
						this.changePayTab(4);
					}else{
						this.changePayTab(2);
					}
				}
			},
			copyText() {
				var text = '';
				/*
				text += '打款金额：¥ ' + this.orderData.total_fee + '\r\n';
				text += '收款账号：0200 0014 0920 0070 931\r\n';
				text += '收款公司名称：机械工业出版社有限公司\r\n';
				text += '开户行：中国工商银行北京百万庄支行\r\n';
				text += '备注信息：' + this.orderData.remark + '\r\n';
				*/
				text += '打款金额：¥ ' + this.orderData.total_fee + '\r\n';
				text += '收款账号：'+ this.orderData.transfer_info.bank_account_number +'\r\n';
				text += '收款公司名称：'+this.orderData.transfer_info.bank_account_name +'\r\n';
				text += '开户行：'+this.orderData.transfer_info.bank_name+'\r\n';
				if(this.orderData.transfer_info.transfer_text){
					text += '备注信息：' + this.orderData.transfer_info.transfer_text + '\r\n';
				}else{
					text += '备注信息：' + this.orderData.remark + '\r\n';
				}
				
				this.$copyText(text).then((res) => {
					//console.log("内容已复制到剪切板")
					this.$alert('内容已复制到剪切板', '提示');
				}).catch((err) => {
					//console.log("抱歉，复制失败")
					this.$alert('抱歉，复制失败', '提示');
				})
			},
			downloadClick() {
				download("https://images.cmptt.com/h5/cmptt/file/t_8h28e4cf4ef6574730a16bc569232e0e/202405301625.docx",
					"第三届无人机职业教育教学资源建设委员会委员申报表.docx");
			},
			changePackageItems(e) {
				
				this.dynamicValidateForm.domains.forEach((item, index) => {
					item.package_items = e;
					item.package_items_title = this.detailData.package_items.filter(i => i.id == e.toString())[0].title;
					if(index!=0){
						item.package_items_disabled = true;
					}
					
					if(this.detailData.case_type != 2){
						if(item.package_items_title.indexOf('线上')>-1){
							item.is_show_more =false;
						}else{
							item.is_show_more =true;
						}
					}else{
						item.is_show_more = false;
					}
				})
				
				var job_type = this.dynamicValidateForm.domains[0].job_type;
				var _package_item = this.detailData.package_items.filter(i => i.id == e.toString())[0];
				
				if (job_type == '学生' && _package_item.student_price) {
					this.price = parseFloat(_package_item.student_price);
				} else if((job_type == '其他' || job_type == '企业人员') && _package_item.company_price){
					this.price = parseFloat(_package_item.company_price);
				} else {
					this.price = parseFloat(_package_item.price);
				}
				this.total_fee = this.price * this.gift_count * 1.00;
				this.bindInvoiceData();
				this.isGiftAdd();
			},
			inputEmailBlurEvent(){
				var email = this.dynamicValidateForm2.domains[0].email;
				if (!email) {
					this.dynamicValidateForm2.domains[0].email = this.dynamicValidateForm.domains[0].email;
				}
			},
			inputMobileBlurEvent() {
				var mobile = this.dynamicValidateForm2.domains[0].mobile;
				if (!mobile) {
					this.dynamicValidateForm2.domains[0].mobile = this.dynamicValidateForm.domains[0].mobile;
					if(!this.inviter){
						this.getInviter(this.dynamicValidateForm.domains[0].mobile);
					}
				}
			},
			getInviter(mobile){
				var that = this;
				this.Ajax(apiUrl.tt_camp_inviter_get, {
					id: that.id,
					mobile: mobile,
				}, (data,code) => {
					that.inviter = data;
					console.log(JSON.stringify(that.inviter))
					that.price = 0.00;
					that.total_fee = that.price * that.gift_count * 1.00;
					that.bindInvoiceData();
				}, (data, code) => {
					
				});
			},
			bindInvoiceData() {
				if (this.total_fee && this.total_fee > 0) {
					this.checked = true;
				} else {
					this.checked = false;
				}

				var type = this.dynamicValidateForm2.domains[0].invoice_make_type;
				if (type) {
					if (type == "单独开具") {
						this.dynamicValidateForm2.domains[0].invoice_count = this.gift_count;
						this.dynamicValidateForm2.domains[0].total_fee = this.price.toString();
						this.dynamicValidateForm2.domains[0].gift_buy_count = 1;
						this.dynamicValidateForm2.domains[0].price = this.price.toString();
						var invoice_unit = this.dynamicValidateForm2.domains[0].invoice_unit;
						if(invoice_unit!='人'){
							this.dynamicValidateForm2.domains[0].invoice_unit = '人';
						}
					} else {
						this.dynamicValidateForm2.domains[0].invoice_count = 1;
						this.dynamicValidateForm2.domains[0].total_fee = this.total_fee.toString();
						this.dynamicValidateForm2.domains[0].gift_buy_count = this.gift_count;
						this.dynamicValidateForm2.domains[0].price = this.price.toString();
						var invoice_unit = this.dynamicValidateForm2.domains[0].invoice_unit;
						if(invoice_unit!='人' && this.gift_count == 1){
							this.dynamicValidateForm2.domains[0].invoice_unit = '人';
						}
					}
				}
			},
			isGiftAdd() {
				var next_total_fee = this.price * (this.gift_count + 1) * 1.00;
				if (next_total_fee > 80000.00) {
					this.is_gift_add = false;
				} else {
					if(this.inviter){
						if(this.gift_count >= parseInt(this.inviter.gift_buy_count)){
							this.is_gift_add = false;
						}else{
							this.is_gift_add = true;
						}
					}else{
						this.is_gift_add = true;
					}
				}

			},
			scrollTop() {
				this.backtop_id = Date.now().toString();
				this.$nextTick(() => {
					//window.scrollTop(0,0);
					window.location.hash = this.backtop_id;
				});
			},
			toStudyClick() {
				var url = "/trainingCamp/study";
				var query = {
					id: this.id
				};
				let routeUrl = this.$router.resolve({
					path: url,
					query: query,
				});
				window.open(routeUrl.href, "_blank");
			},
			checkedChangeEvent(e) {
				if (!e) {
					this.checked = true;
					this.$confirm('您确认不需要开具发票么，确认后会务组将不再为您开具发票?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$message({
							type: 'success',
							message: '设置成功!'
						});
						this.checked = false;
					}).catch(() => {
						this.$message({
							type: 'info',
							message: '已取消操作'
						});
					});
				}
			},
			jobTypeChangeEvent() {
				var _package_item = null;
				if (this.detailData.package_items && this.detailData.package_items.length > 0 && this.dynamicValidateForm.domains[0].package_items) {
					var _package_items = this.dynamicValidateForm.domains[0].package_items;
					_package_item = this.detailData.package_items.filter(i => i.id == _package_items.toString())[0];
				}
				
				//有学生价时，身份变更时，定价更新
				if (this.detailData.student_price 
				|| this.detailData.company_price 
				|| (_package_item && _package_item.student_price) 
				|| (_package_item && _package_item.company_price)
				) {
					if (!this.dynamicValidateForm.domains[0].job_type) {
						var _job_type = '';
						this.dynamicValidateForm.domains.forEach((item, index) => {
							if (item.job_type) {
								_job_type = item.job_type;
							}
						})
						this.dynamicValidateForm.domains[0].job_type = _job_type;
					}

					this.dynamicValidateForm.domains.forEach((item, index) => {
						item.job_type = this.dynamicValidateForm.domains[0].job_type;
						if (index != 0) {
							item.job_type_disabled = true;
						}
					})
					
					var job_type = this.dynamicValidateForm.domains[0].job_type;
					if(_package_item){
						if (job_type == '学生' && _package_item.student_price) {
							this.price = parseFloat(_package_item.student_price);
						} else if((job_type == '其他' || job_type == '企业人员') && _package_item.company_price){
							this.price = parseFloat(_package_item.company_price);
						} else {
							this.price = parseFloat(_package_item.price);
						}
					}else{
						if (job_type == '学生' && this.detailData.student_price) {						
							this.price = parseFloat(this.detailData.student_price);
						} else if((job_type == '其他' || job_type == '企业人员') && this.detailData.company_price){
							this.price = parseFloat(this.detailData.company_price);
						} else {
							this.price = parseFloat(this.detailData.price);
						}
					}

					this.total_fee = this.price * this.gift_count * 1.00;
					this.bindInvoiceData();

				}
			},
			isCertChangeEvent() {
				if (this.detailData.cert_fee) {

					if (!this.dynamicValidateForm.domains[0].is_cert) {
						var _is_cert = '';
						this.dynamicValidateForm.domains.forEach((item, index) => {
							if (item.is_cert) {
								_is_cert = item.is_cert;
							}
						})
						this.dynamicValidateForm.domains[0].is_cert = _is_cert;
					}

					this.dynamicValidateForm.domains.forEach((item, index) => {
						item.is_cert = this.dynamicValidateForm.domains[0].is_cert;
						if (index != 0) {
							item.is_cert_disabled = true;
						}
					})

					
					
					if (this.dynamicValidateForm.domains[0].is_cert == '是') {
						if(this.inviter){
							this.price =  parseFloat(this.detailData.cert_fee);
						}else{
							this.price = parseFloat(this.detailData.price) + parseFloat(this.detailData.cert_fee);
						}
						
					} else {
						if(this.inviter){
							this.price = 0.00;
						}else{
							this.price = parseFloat(this.detailData.price);
						}
					}
					
					
					this.total_fee = this.price * this.gift_count * 1.00;
					this.bindInvoiceData();
				}
			},
			addDomain() {
				var _package_items = '';
				var _package_items_title = '';
				var _package_items_disabled = false;
				var _package_item = null;
				var _job_type = '';
				var _job_type_disabled = false;
				var _school = '';
				var _college = '';
				var _company = '';
				var _is_cert = '';
				var _is_cert_disabled = false;
				var _is_show_more = true;
				var _check_in_date = '';
				var _stay_type ='';
				
				if(this.id == 't_f6c67deb3ffe4346a601e7f28d577dd9'){
					_stay_type = '自行安排';
				}
				
				if(this.detailData.job_type_items && this.detailData.job_type_items.length == 1){
					_job_type = this.detailData.job_type_items[0];
				}

				if(this.dynamicValidateForm.domains[0].check_in_date){
					_check_in_date = this.dynamicValidateForm.domains[0].check_in_date;
				}

				if(this.detailData.case_type ==2 && _is_show_more){
					_is_show_more = false;
				}
				
				if(this.detailData.package_items && this.detailData.package_items.length>0 && this.dynamicValidateForm.domains[0].package_items){
					_package_items = this.dynamicValidateForm.domains[0].package_items;
					_package_item = this.detailData.package_items.filter(i => i.id == _package_items.toString())[0];
					_package_items_title = _package_item.title;
					_package_items_disabled = true;
					if(_package_items_title.indexOf('线上')>-1 && _is_show_more){
						_is_show_more = false;
					}
				}
				
				if ((this.detailData.student_price || this.detailData.company_price || (_package_item && _package_item.student_price) || (_package_item && _package_item.company_price)) && this.dynamicValidateForm.domains[0].job_type) {
					_job_type = this.dynamicValidateForm.domains[0].job_type;
					_job_type_disabled = true;
				}
				if (this.dynamicValidateForm.domains[0].school) {
					_school = this.dynamicValidateForm.domains[0].school;
				}
				if (this.dynamicValidateForm.domains[0].college) {
					_college = this.dynamicValidateForm.domains[0].college;
				}
				if (this.dynamicValidateForm.domains[0].company) {
					_company = this.dynamicValidateForm.domains[0].company;
				}
				if (this.dynamicValidateForm.domains[0].is_cert) {
					_is_cert = this.dynamicValidateForm.domains[0].is_cert;
					_is_cert_disabled = true;
				}

				this.dynamicValidateForm.domains.push({
					package_items: _package_items,
					package_items_title: _package_items_title,
					package_items_disabled: _package_items_disabled,
					is_show_more: _is_show_more,
					name: '',
					mobile: '',
					sex: '',
					job_type: _job_type,
					job_type_disabled: _job_type_disabled,
					school_pca: '',
					school_province: '',
					school_city: '',
					school_area: '',
					school: _school,
					college: _college,
					title: '',
					title_other: '',
					duty: '',
					duty_other: '',
					teaching_length: '',
					subject: '',
					company: _company,
					education: '',
					diet_type: '',
					check_in_date: _check_in_date,
					check_in_date_other: '',
					check_in_plate_number: '',
					stay_type: _stay_type,
					hotel: '',
					room_type_before: '',
					room_type: '',
					room_type_other: '',
					room_share_with: '',
					stay_days_arr: '',
					stay_days: '',
					stay_days_other: '',
					is_visit: '',
					visit_plate_number: '',
					is_join: '',
					is_will: '',
					id_card: '',
					is_cert: _is_cert,
					is_cert_disabled: _is_cert_disabled,
					pca: '',
					province: '',
					city: '',
					area: '',
					address: '',
					email: '',
					course: '',
					major: '',
					department: '',
					hotel_check_in: '',
					hotel_check_out: '',
					is_member: '',
					wechat_id: '',
					is_report: '',
					report_title: '',
					is_speak: '',
					speak_title: '',
					interested: '',
					interested_arr: '',
					dine_items: '',
					dine_items_arr: [],
					img_list: [],
					file_list: [],
					key: Date.now()
				});
				this.gift_count++;
				this.total_fee = this.price * this.gift_count * 1.00;
				this.bindInvoiceData();
				this.isGiftAdd();
			},
			removeDomain(item) {
				var index = this.dynamicValidateForm.domains.indexOf(item)
				if (index !== -1) {
					this.dynamicValidateForm.domains.splice(index, 1)
					this.dynamicValidateForm2.domains.splice(index, 1)
					this.gift_count--;
					this.total_fee = this.price * this.gift_count * 1.00;
					this.bindInvoiceData();
					this.isGiftAdd();
				}
			},
			infoConfirm() {
				var that = this;
				that.$refs['dynamicValidateForm'].validate((valid) => {
					if (valid) {
						
						that.dynamicValidateForm.domains.forEach((item,index)=>{
							if(item.school_pca && item.school_pca.length == 3){
								item.school_province = item.school_pca[0];
								item.school_city = item.school_pca[1];
								item.school_area = item.school_pca[2];
							}
							
							if(item.pca && item.pca.length == 3){
								item.province = item.pca[0];
								item.city = item.pca[1];
								item.area = item.pca[2];
							}
						});
							
						if(this.checked){
							//包含开票信息
							that.$refs['dynamicValidateForm2'].validate((_valid) => {
								if (_valid) {
									console.log('可以提交')
									console.log(this.dynamicValidateForm.domains)
							
									console.log('dynamicValidateForm' + JSON.stringify(that.dynamicValidateForm
										.domains))
									console.log('dynamicValidateForm2' + JSON.stringify(that
										.dynamicValidateForm2.domains))
							
									that.search.id = this.id;
									that.search.gift_buy_count = this.gift_count;
									that.search.user_list_json = JSON.stringify(that.dynamicValidateForm
										.domains);
									that.search.invoice_list_json = JSON.stringify(that.dynamicValidateForm2
										.domains);
									that.goToOrder();
								}
							});
							
						}else{ 
							//不包含开票信息
							console.log('可以提交')
							console.log(this.dynamicValidateForm.domains)
														
							console.log('dynamicValidateForm' + JSON.stringify(that.dynamicValidateForm
								.domains))
					
							that.search.id = this.id;
							that.search.gift_buy_count = this.gift_count;
							that.search.user_list_json = JSON.stringify(that.dynamicValidateForm
								.domains);
							that.goToOrder();
						}

					}
				});
			},
			changePayMethod(index) {
				var that = this;
				that.page_index = 2;
				that.detailData.tt_out_trade_no = that.orderData.out_trade_no;
				that.changePayTab(index);
				that.scrollTop();
			},
			goToOrder() {
				var that = this;
				this.search.is_invoice = this.checked ? 1:0;
				var url = apiUrl.tt_purchase_confirm;
				this.Ajax(url, this.search, (data) => {
					that.orderData = data;
					that.page_index = 2;
					that.stateData = {
						pay_method: that.orderData.pay_method,
						result: that.orderData.result,
						applyer: that.orderData.applyer,
						applyer_count:that.orderData.applyer_count,
						time: that.orderData.time,
						place:that.orderData.place,
						is_offline_pay:that.orderData.is_offline_pay,
					};
					that.scrollTop();
				},(data,code,msg)=>{
					that.$message.error(msg);
				});
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (formName == 'dynamicValidateForm') {
							this.alert_show1 = true;
						} else if (formName == 'dynamicValidateForm2') {
							this.alert_show2 = true;
						}
					} else {
						console.log('error submit!!');
						if (formName == 'dynamicValidateForm') {
							this.alert_show1 = false;
						} else if (formName == 'dynamicValidateForm2') {
							this.alert_show2 = false;
						}
						return false;
					}
				});
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			},
			changePayTab(index) {
				var that = this;
				this.pay_tab_index = index;
				that.$nextTick(() => {
					that.updateOrderInfoAjax(index, (data) => {
						console.log(data);
						that.orderData = data;
						if (that.orderData && that.orderData.qrcode_url && index == 1) {
							that.setupQrCode(that.$refs.qrcode, that.orderData.qrcode_url, 230, (
								code_img) => {
									that.qrcode = code_img;
								});
						}
					})
				});
			},
			updateOrderInfoAjax(index, callback) {
				var that = this;
				var url = apiUrl.tt_order_info_update;
				this.Ajax(url, {
					out_trade_no: that.orderData.out_trade_no,
					product_type: that.orderData.product_type,
					pay_method: index
				}, (data) => {
					if (callback) callback(data);
				});
			},
			updateOrderInfo() {
				this.page_index = 2;
				this.checkOrderState();
			},
			finishConfirm() {
				this.page_index = 2;
				this.checkOrderState();
			},
			checkOrderState() {
				var that = this;
				var url = apiUrl.tt_order_state_check;
				this.Ajax(url, {
					out_trade_no: this.orderData.out_trade_no
				}, (data) => {
					that.stateData = data;
					that.scrollTop();
				});
			},
			getDetail() {
				var that = this;
				var url = apiUrl.tt_camp_detail_get;
				var parms = {
					id: this.id,
					is_sign_up: 1
				};
				if (this.path) {
					parms = {
						id: this.id,
						is_sign_up: 1,
						path: this.path
					};
				}
				this.Ajax(url, parms, (data) => {
					that.detailData = data;
					if(data.arrival_at){
						var date = new Date(data.arrival_at);
						var start_date = new Date(data.start_at);
						var next_date  = new Date(data.stop_at);
						//var next_date  = new Date(data.arrival_at);
						//next_date =new Date(next_date.setDate(next_date.getDate()+2));
						
						that.defaultStartDate = `${date.getFullYear()}-${date.getMonth()+1}-${date.getDate()}`;
						that.defaultEndDate = `${next_date.getFullYear()}-${next_date.getMonth()+1}-${next_date.getDate()}`;
						that.defaultStartDate2 = `${date.getFullYear()}-${date.getMonth()+1}-${date.getDate()} 12:00:00`;
						that.defaultReportDate = `${start_date.getFullYear()}-${start_date.getMonth()+1}-${start_date.getDate()} 09:00:00`;
						
						var arr=new Array();
						arr.push(that.defaultStartDate);
						arr.push(that.defaultEndDate);
						that.defaultRangeDate = arr;
					}
					
					if (that.detailData.is_package != 1) {
						that.price = parseFloat(that.detailData.price);
					} else {
						/*
						var item = that.detailData.package_items[that.detailData.package_items.length-1];
						that.dynamicValidateForm.domains[0].package_items = item.id;
						that.price = parseFloat(item.price);
						*/
					}
					
					if(this.detailData.package_items && this.detailData.package_items.length>0 && this.dynamicValidateForm.domains[0].package_items){
						_package_items = this.dynamicValidateForm.domains[0].package_items;
						_package_item = this.detailData.package_items.filter(i => i.id == _package_items.toString())[0];
						_package_items_title = _package_item.title;
						_package_items_disabled = true;
						if(_package_items_title.indexOf('线上')>-1 && _is_show_more){
							_is_show_more = false;
						}
					}

					if(that.detailData.case_type == 2){
						that.dynamicValidateForm.domains[0].is_show_more = false;
					}
					
					//身份类型
					if(this.detailData.job_type_items && this.detailData.job_type_items.length == 1){
						that.dynamicValidateForm.domains[0].job_type = this.detailData.job_type_items[0];
					}
					
					//发票类目
					if(this.detailData.invoice_category_items && this.detailData.invoice_category_items.length>0){
						that.dynamicValidateForm2.domains[0].category = this.detailData.invoice_category_items[0];
					}
					
					if(that.id == 't_f6c67deb3ffe4346a601e7f28d577dd9'){
						that.dynamicValidateForm.domains[0].stay_type = '自行安排';
					}

					if (that.detailData.is_reg == 0) {
						that.page_index = 1;
						that.gift_count = 1;
						that.total_fee = that.price * that.gift_count * 1.00;
						that.bindInvoiceData();
						that.isGiftAdd();
					} else if (that.detailData.order_info) {
						that.page_index = 2;

						that.stateData = {
							pay_method: that.detailData.order_info.pay_method,
							result: that.detailData.order_info.result,
							applyer: that.detailData.order_info.applyer,
							applyer_count:that.detailData.order_info.applyer_count,
							time: that.detailData.order_info.time,
							place:that.detailData.order_info.place,
							is_offline_pay:that.detailData.order_info.is_offline_pay,
						};

						that.orderData = {
							total_fee: that.detailData.order_info.total_fee,
							original_total_fee: that.detailData.order_info.original_total_fee,
							discount_fee: that.detailData.order_info.discount_fee,
							out_trade_no: that.detailData.order_info.out_trade_no,
							product_id: that.detailData.order_info.product_id,
							product_type: that.detailData.order_info.product_type,
							remark: that.detailData.order_info.remark,
							qrcode_url: that.detailData.order_info.qrcode_url,
							media_list: that.detailData.order_info.media_list,
							file_list: that.detailData.order_info.file_list,
							transfer_info: that.detailData.order_info.transfer_info,
							group_qrcode_url: that.detailData.order_info.group_qrcode_url,
						};
					}
				});
			},
			//QrCode
			setupQrCode(el, url, width, callback) {
				let code_img = new QRCode(el, {
					width: width,
					height: width, // 高度
					text: url, // 二维码内容
					colorDark: '#333333',
					colorLight: '#ffffff',
					correctLevel: QRCode.CorrectLevel.L,
				});
				if (callback) callback(code_img);
			},
			getInvoiceTitleList() {
				var that = this;
				var url = apiUrl.tt_invoice_title_list_get;
				this.Ajax(url, {}, (data) => {
					that.invoice_title_list = data;
				});
			},
			querySearch(queryString, cb) {
				var restaurants = this.invoice_title_list;
				var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
				
				// 调用 callback 返回建议列表的数据
				cb(results);
			},
			createFilter(queryString) {
				return (restaurant) => {
				  return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
				};
			},
			handleSelect(item) {
				console.log(item);
				if(item){
					this.dynamicValidateForm2.domains[0].tax_id = item.address;	
				}
			},
			/*上传图片付款凭证 开始*/
			handleImgExceed(files, uploadFiles)  {
				this.$message.error("最多上传3个图片");
			},
			handleImgChange(file, fileList) {
				const MAX_SIZE = 1024 * 1024 * 5; // 5MB
				var arr =new Array();
				fileList.forEach((f,index)=>{
					if (f.size > MAX_SIZE) {
						this.$message.error('每个文件大小不能超过5MB!');
					}else{
						arr.push(f);
					}
				})
				this.imgList = arr;
			},
			delImgClick(item) {
				this.imgList = this.imgList.filter(i => i != item);
			},
			uploadImgConfirmClick(){
				var that = this;
				if(this.imgList.length == 0){
					this.$message.error("请上传图片");
					return;
				}
			
				var url = apiUrl.tt_camp_order_media_upload;
				var formData = new FormData();
				this.imgList.forEach((file,index) => {
					formData.append("file"+index, file.raw);
				});
				var token = "";
				var userInfo = JSON.parse(localStorage.getItem("userLogInInfo"));
				if (userInfo && userInfo.token != '') {
					token = userInfo.token;
				}
				formData.append("token", token);
				formData.append("client_type", 10);
				formData.append("out_trade_no", that.orderData.out_trade_no);
				that.Ajax(url, formData, (data) => {
					that.$message.success("上传成功");
					that.orderData.media_list = data;
					that.imgList = [];
				});
				
			},
			loadPreviewSrcList(){
				if(this.orderData.media_list){
					var arr =new Array();
					this.orderData.media_list.forEach((item,index)=>{
						arr.push(item.img_url);
					})
					return arr;
				}else{
					return [];
				}
			},
			getFileSize(bytes){
				if(bytes >= 1048576){
					return (bytes/1048576).toFixed(2)+' MB';
				}else if(bytes >= 1024){
					return (bytes/1024).toFixed(2)+' KB';
				}else {
					return bytes +' bytes';
				}
			},
			getImgUrl(raw){
			   return URL.createObjectURL(raw);
			},
			getFileExt(name){
				var values = name.split('.');
				return '.'+values[values.length-1].toLowerCase();
			},
			/*上传图片付款凭证 结束*/
			
			/*个人上传图片 开始*/
			delImgClick2(index, item) {
				this.dynamicValidateForm.domains[index].img_list = this.dynamicValidateForm.domains[index].img_list.filter(
					i => i != item);
			},
			handleImgExceed2(files, fileList,index){
				this.$message.error("最多上传"+ this.detailData.form_image_limit +"张图片");
			},
			handleImgChange2(file, fileList,index){
				const MAX_SIZE = 1024 * 1024 * 5; // 5MB
				var arr =new Array();
				fileList.forEach((f,index)=>{
					if (f.size > MAX_SIZE) {
						this.$message.error('每张图片大小不能超过5MB!');
					}else{
						arr.push(f);
					}
				})
	
				var that = this;
				var formData = new FormData();
				arr.forEach((f,index) => {
					formData.append("file"+index, f.raw);
				});
				var token = "";
				var userInfo = JSON.parse(localStorage.getItem("userLogInInfo"));
				if (userInfo && userInfo.token != '') {
					token = userInfo.token;
				}
				formData.append("token", token);
				formData.append("client_type", 10);
				var url = apiUrl.tt_media_upload;
				that.Ajax(url, formData, (data) => {
					that.$message.success("上传成功");
					that.dynamicValidateForm.domains[index].img_list = that.dynamicValidateForm.domains[index].img_list.concat(data);
					console.log(JSON.stringify(that.dynamicValidateForm.domains[index].img_list))
				});
			},
			/*个人上传图片 结束*/
			
			/*个人上传文件（非图片） 开始*/
			delFileClick2(index, item) {
				this.dynamicValidateForm.domains[index].file_list = this.dynamicValidateForm.domains[index].file_list.filter(
					i => i != item);
			},
			handleFileExceed2(files, fileList,index){
				this.$message.error("最多上传"+ this.detailData.form_file_limit +"个文件");
			},
			handleFileChange2(file, fileList,index){
				const MAX_SIZE = 1024 * 1024 * 5; // 5MB
				var arr =new Array();
				fileList.forEach((f,index)=>{
					if (f.size > MAX_SIZE) {
						this.$message.error('每个文件大小不能超过5MB!');
					}else{
						arr.push(f);
					}
				})
				
				var that = this;
				var formData = new FormData();
				arr.forEach((f,index) => {
					formData.append("file"+index, f.raw);
				});
				var token = "";
				var userInfo = JSON.parse(localStorage.getItem("userLogInInfo"));
				if (userInfo && userInfo.token != '') {
					token = userInfo.token;
				}
				formData.append("token", token);
				formData.append("client_type", 10);
				var url = apiUrl.tt_media_upload;
				that.Ajax(url, formData, (data) => {
					that.$message.success("上传成功");
					that.dynamicValidateForm.domains[index].file_list = that.dynamicValidateForm.domains[index].file_list.concat(data);
					console.log(JSON.stringify(that.dynamicValidateForm.domains[index].file_list))
				});
			},
			/*个人上传文件（非图片） 结束*/
			
			/*上传文件相关 开始*/
			handleFileExceed(files, uploadFiles)  {
				this.$message.error("最多上传3个文件");
			},
			handleFileChange(file, fileList) {
				const MAX_SIZE = 1024 * 1024 * 5; // 5MB
				var arr =new Array();
				fileList.forEach((f,index)=>{
					if (f.size > MAX_SIZE) {
						this.$message.error('每个文件大小不能超过5MB!');
					}else{
						arr.push(f);
					}
				})
				this.fileList = arr;
			},
			delFileClick(item) {
				this.fileList = this.fileList.filter(i => i != item);
			},
			uploadFileConfirmClick(){
				var that = this;
				if(this.fileList.length == 0){
					this.$message.error("请上传文件");
					return;
				}

				var url = apiUrl.tt_camp_order_media_upload;
				var formData = new FormData();
				this.fileList.forEach((file,index) => {
					formData.append("file"+index, file.raw);
				});
				var token = "";
				var userInfo = JSON.parse(localStorage.getItem("userLogInInfo"));
				if (userInfo && userInfo.token != '') {
					token = userInfo.token;
				}
				formData.append("token", token);
				formData.append("client_type", 10);
				formData.append("out_trade_no", that.orderData.out_trade_no);
				that.Ajax(url, formData, (data) => {
					that.$message.success("上传成功");
					that.orderData.file_list = data;
					that.fileList = [];
				});
				
			},	
			/*上传文件相关 结束*/
			stayDaysConfirmEvent(e,_index){
				console.log(JSON.stringify(e))
				var startDate = e[0];
				var endDate = e[1];
				var index = parseInt(_index);
				var item = this.dynamicValidateForm.domains[index];
				var night = this.calculateNights(startDate,endDate);
				if(night == 0){
					this.$message.error("入住时间与离店时间不可以是同一天，请调整");
					e[0] = '';
					e[1] = '';
					item.stay_days_arr = [];
					item.stay_days = '';
					item.hotel_check_in = '';
					item.hotel_check_out = '';
					return;
				}
				var arr=new Array();
				arr.push(startDate);
				arr.push(endDate);
				item.stay_days_arr = arr;
				item.stay_days = startDate + " 至 "+endDate+"（共"+ night+"晚）";
				item.hotel_check_in = startDate;
				item.hotel_check_out = endDate;
			},
			calculateNights(checkInDateStr, checkOutDateStr) {
			    // 将字符串转换为日期对象
			    const checkInDate = new Date(checkInDateStr);
			    const checkOutDate = new Date(checkOutDateStr);
			 
			    // 设置时间为当天的午夜，避免时分秒的干扰
			    checkInDate.setHours(0, 0, 0, 0);
			    checkOutDate.setHours(0, 0, 0, 0);
			 
			    // 计算两个日期之间的毫秒数差异，然后转换为天数
			    const diffTime = Math.abs(checkOutDate - checkInDate);
			    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
			 
			    return diffDays;
			},
			//比较参会者所选报到日是否与通知上的报到日一致
			isSameDay(checkInDateStr, arrivalAtStr) {
				// 将字符串转换为日期对象
				const checkInDate = new Date(checkInDateStr);
				const arrivalAt = new Date(arrivalAtStr);
			
				// 设置时间为当天的午夜，避免时分秒的干扰
				checkInDate.setHours(0, 0, 0, 0);
				arrivalAt.setHours(0, 0, 0, 0);
			
				// 计算两个日期之间的毫秒数差异，然后转换为天数
				const diffTime = Math.abs(checkInDate - arrivalAt);
				if(diffTime == 0){
					return true;
				}else{
					return false;
				}
			},
		},
	};
</script>
<style>
	/*单选按钮*/
	/* .el-radio__input.is-checked + .el-radio__label {
	  color: #606266 !important;
	}

	.el-radio__input.is-checked .el-radio__inner {
	  background: #606266 !important;
	  border-color: #606266 !important;
	}
	.el-radio__input:hover{
		border-color: #DCDFE6 !important;
	} */
	
	.report_date .el-date-table__row .available.default:not(.disabled,.current,.start-date,.end-date) span,
	.stay_days .el-date-table__row .available.default:not(.disabled,.current,.start-date,.end-date) span{
		color: red;
	}
	
	.report_date .el-date-table__row .available.current span::after{
		content: '报告';
		display: block;
		margin-top: -3px;
		font-size: 10px;
		color: #409EFF;
		font-weight: 600;
		z-index: 9;
	}
	
	
	.stay_days .el-date-table__row .available.current span::after{
		content: '报到';
		display: block;
		margin-top: -3px;
		font-size: 10px;
		color: #409EFF;
		font-weight: 600;
		z-index: 9;
	}
	
	.stay_days .el-date-table__row .available.start-date span::after{
		content: '入住';
		display: block;
		margin-top: -3px;
		font-size: 10px;
		font-weight: 600;
		color: #409EFF;
		z-index: 9;
	}
	.el-date-editor .el-range-separator{
		 width: 30px !important;
	}
	.stay_days .el-date-table__row .available.end-date span::after{
		content: '离店';
		display: block;
		margin-top: -3px;
		font-size: 10px;
		color: #409EFF;
		font-weight: 600;
		z-index: 9;
	}
	.label_top .el-form-item__label{
		width: 100% !important;
		justify-content: flex-start !important;
		padding-left: 260px;
		box-sizing: border-box;
	}
	
	.sign_up_container .el-upload-dragger{
		height: 72px !important;
		display: flex;
		justify-content: center;
		align-items: center;
	}
</style>

<style lang="scss" scoped>
	
	.page-main {
		width: 100%;
		min-height: 100vh;
		background: #F1F1F1;
		display: flex;
		flex-direction: column;
		align-items: center;
		position: relative;

		.pay_tabs {
			display: flex;
			margin-top: 20px;

			.pay_tab {
				font-size: 22px;
				display: flex;
				justify-content: center;
				align-items: center;
				width: 315px;
				height: 90px;
				background-color: #F1F1F1;
				border-radius: 10px;
				position: relative;
				box-sizing: border-box;
				cursor: pointer;
				margin-right: 30px;

				&.actived {
					background-color: #fff;
					border: 2px solid #ff9000;


				}

				.tag {
					background-color: #ff9000;
					width: 30px;
					height: 20px;
					display: flex;
					justify-content: center;
					align-items: center;
					border-radius: 10px 0 10px 0;
					position: absolute;
					right: -2px;
					bottom: -2px;
					box-sizing: border-box;
				}
			}
		}

		/deep/.sign_up_container {
			/*复选按钮*/
			.el-checkbox__input.is-checked .el-checkbox__inner,
			.el-checkbox__input.is-indeterminate .el-checkbox__inner {
				background-color: #FCA459 !important;
				border-color: #FCA459 !important;
			}

			.el-checkbox__input.is-focus .el-checkbox__inner {
				border-color: #FCA459 !important;
			}

			.el-checkbox__label {
				font-size: 15px;
				//color: #333 !important;
			}

			.el-checkbox__input.is-checked+.el-checkbox__label {
				color: #FCA459 !important;
			}

			.el-radio {
				line-height: 2 !important;
			}

			.el-collapse {
				border: none !important;
			}

			.el-collapse-item__wrap {
				border: none !important;
			}

			.el-collapse-item__header {
				padding-left: 156px;
				box-sizing: border-box;
				border: none !important;
			}

			.el-alert {
				padding: 16px;
			}

			.el-alert__title {
				font-size: 15px;
			}

			.el-alert .el-alert__description {
				font-size: 14px;
			}

			.el-form-item__label {
				line-height: 1.4;
				display: inline-flex;
				justify-content: flex-end;
				align-items: center;
				height: 40px;
			}
			
			.pic2_box{
				display: flex;
				flex-direction: column;
				width: 360px; 
				margin-top: 15px;
				
				.pic_box-title{
					font-size: 26upx;
					line-height: 1.75;
					color: #444;
					margin-bottom: 20upx;
				}
				.pic {
					width: 100%;
					height: 72px;
					border: 1px solid #e0e0e0;
					background-color: #fff;
					border-radius: 4px;
					padding: 12px;
					box-sizing: border-box;
					display: flex;
					justify-content: center;
					align-items: center;
					line-height: 1;
					margin-top: 10px;
					
				
					.image_box {
						width: 48px;
						height: 48px;
						margin-right: 12px;
				
						.image {
							width: 48px;
							height: 48px;
							border: 1px solid #eee;
							
							&.file{
								border: none !important;
							}
						}
					}
				
					.info {
						flex: 1;
						height: 38px;
						display: flex;
						flex-direction: column;
						justify-content: space-between;
				
						.title {
							width: 200px;
							font-size: 14px;
							color: #333;
							overflow: hidden;
							text-overflow: ellipsis;
							white-space: nowrap;
							word-break: break-word;
						}
				
						.exts {
							display: flex;
							justify-content: space-between;
							align-items: flex-end;
							
				
							.media_size {
								font-size: 14px;
								color: #999;
							}
				
							.delicon {
								width: 20px;
								cursor: pointer;
							}
						}
					}
				}
				
			}
			


		}
		
	

		/*
		.sign_up_container {
			/deep/ .el-radio__label {
				font-size: 18px !important;
			}

			/deep/ .el-radio__inner {
				border-radius: 4px !important;
				width: 20px !important;
				height: 20px !important;
				background-color: #fff !important;
			}

			/deep/ .el-radio__inner::after {
				width: 12px !important;
				height: 12px !important;
				border-radius: 4px !important;
				background-color: #999 !important;
			}

			/deep/ .el-radio__input.is-checked+.el-radio__label {
				color: rgb(153, 153, 153) !important;
			}

			/deep/ .el-checkbox__input.is-checked+.el-checkbox__label {
				color: #666 !important;
			}

			/deep/ .el-checkbox__label {
				font-size: 14px;
			}

			/deep/ .el-checkbox__inner {
				border-radius: 4px !important;
				width: 20px !important;
				height: 20px !important;
				background-color: #fff !important;
			}

			/deep/ .el-checkbox__inner::after {
				width: 12px !important;
				height: 12px !important;
				border-radius: 4px !important;
				background-color: #999 !important;
				box-sizing: content-box;
			}
		}
		*/
	  
	}
</style>